import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MemberService} from '../services/member.service';
import {Ordered} from '../models/ordered';
import {OrderedService} from '../services/ordered.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-annuity-gn1',
  templateUrl: './annuity-gn1.component.html',
  styleUrls: [ './annuity-gn1.component.scss' ]
})
export class AnnuityGn1Component implements OnInit {

  public annuity_id: string = "t1RvzJlW5CbjzImWd5Cg"
  public annuity_name: string = "Anuidade 2004 • SBCCV"
  public proofOfSale: string = "GN1-2004"
  public annuity_from: string = "2004"

  public sbccvMembers: any[] = []
  public gn1Annuity: any[] = []
  public array2020: any[] = []

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'name', 'cpf', 'category', 'annuity_from' ];

  constructor (
    private _memberService: MemberService,
    private _ordererService: OrderedService,
    public db: AngularFirestore
  ) {
    this.loadSBCCVMembers()

  }


  ngOnInit () {
  }

  loadSBCCVMembers () {

    this.sbccvMembers = []

    this._memberService.load()
      .subscribe((result) => {

        result.forEach((item) => {

          if (item.data().cpf) {
            let cleanCpf = this.cleanCPF(item.data().cpf)
            let member: any = {
              'id': item.id,
              'name': item.data().name.trim(),
              'debit': item.data().balance,
              'cpf': cleanCpf,
              'cellPhone': item.data().cellPhone,
              'email': item.data().email,
              'subCategory': item.data().subCategory,
              'annuity_from': item.data().annuity_from
            }
            this.sbccvMembers.push(member)
          }
        })

      })
  }

  readCSVFile (fileInput: any) {

    let memberNotFound: any = []

    const fileReaded = fileInput.target.files[ 0 ];

    let reader: FileReader = new FileReader();
    reader.readAsText(fileReaded);

    reader.onload = (e) => {

      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[ 0 ].split(';');
      let lines = [];

      for (var i = 2; i < allTextLines.length; i++) {
        let data = allTextLines[ i ].split(';');

        if (data[ 0 ] != "") {
          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[ j ]);
          }
          lines.push(tarr);
        }
      }

      let countOk: number = 0;
      let countNo: number = 0;
      let countDuplicate: number = 0;
      let array: any[] = []

      for (let i = 0; i < lines.length; i++) {

        let member_cpf = this.cleanCPF(lines[ i ][ 1 ])
        let status_pgto = lines[ i ][ 2 ].toUpperCase()
        let annuity_from = lines[ i ][ 5 ]

        if (status_pgto === 'PAGO' && annuity_from === this.annuity_from) {

          let sbccvMember = this.sbccvMembers.find((e) => {
            return e.cpf === member_cpf
          })

          if (!sbccvMember) {
            memberNotFound.push({'member_cpf': member_cpf})
            //console.log("not found: " + i + " - " + member_cpf)
            countNo++
          } else {

            let entity = this.createEntity(lines[ i ], sbccvMember)

            // verifica duplicidade
            const duplicate = array.find((e) => {
              return entity.member_cpf === e.member_cpf
            })

            if (duplicate) {
              //console.log(i + '--------- DUPLICATE -------------------------')
              //console.log(JSON.stringify(duplicate))
              //console.log()
              countDuplicate++

              // console.log(duplicate.value)
              // console.log(duplicate.total)
              // console.log(i + '-------------------------------')

              duplicate.value = duplicate.value + entity.value
              duplicate.total = duplicate.total + entity.total
              // console.log(duplicate.value)
              // console.log(duplicate.total)
              // console.log(i + '-------------------------------')
              // console.log(i + '-------------------------------')

            } else {
              array.push(entity)
              countOk++

              /*
               this.db.collection('sbccv_orders').add(Object.assign({}, entity))
                 .then((result) => {
                   console.log("annuity_id: " + result.id)
                   console.log(entity.member_name)
                   console.log('---------------------------------')
                 })
                 .catch((err) => {
                   console.log("INSERT ERRO: " + err.message)
                 })
                 */

            }

          }

        }

      }

      console.log("-------------------------------")
      console.log("-------------------------------")

      console.log("countNo: " + countNo)
      console.log("countOk: " + countOk)
      console.log("countDuplicate: " + countDuplicate)

      console.log("-------------------------------")

      console.log(JSON.stringify(array))


    }

  }

  createEntity (line: any, member: any) {

    const order: Ordered = new Ordered()

    order.product_id = this.annuity_id
    order.product_name = this.annuity_name

    order.member_id = member.id
    order.member_name = this.formatName(member.name)
    order.member_cpf = member.cpf
    order.member_cellPhone = member.cellPhone
    order.member_email = member.email

    order.category_id = member.subCategory.id
    order.category_name = member.subCategory.name

    order.origin = 'GN1-i'
    order.proofOfSale = this.proofOfSale

    order.date = this.formatDate(line[ 3 ])
    order.value = this.formatValue(line[ 4 ])
    order.total = this.formatValue(line[ 4 ])
    order.Tid = line[ 6 ]
    order.authorizationCode = line[ 6 ]
    order.paymentId = line[ 6 ]
    order.payment_date = this.formatDate(line[ 3 ])
    order.payment_type = line[ 7 ]
    order.type = line[ 7 ]
    order.returnCode = "00"

    return order

  }

  cleanCPF (cpf: string) {
    let returnCpf: string;
    if (!cpf) {
      returnCpf = ''
    } else {
      returnCpf = cpf.replace('.', '').replace('.', '').replace('.', '').replace('-', '').trim()
    }
    return returnCpf
  }

  formatName (name: string) {
    let data = name.toLowerCase();
    let parts = data.split(" ")

    let changePart: string = parts[ 0 ].substring(parts[ 0 ].length - 1, parts[ 0 ].length)

    if (changePart == ',') {
      parts[ 0 ] = parts[ 0 ].replace(",", "")
      parts.push(parts[ 0 ])
      parts.splice(0, 1)
    }

    let foamatedName: string = "";
    parts.forEach((part) => {
      if (part == 'de' || part == 'da' || part == 'do') {
        foamatedName += part + " "
      } else {
        let first = part.substring(0, 1)
        let last = part.substring(1, part.length)
        foamatedName += first.toUpperCase() + last + " "
      }
    })

    return foamatedName.trim();
  }

  removeEspecials (name) {
    return name.trim().toLowerCase().replace("ã", "a").replace("á", "a").replace("â", "a").replace("é", 'e').replace("ê", 'e').replace("õ", 'o').replace("ô", 'o').replace("ó", 'o').replace("ú", 'u').replace("í", 'i').replace("ç", 'c');

  }
  formatDate (date: string) {
    // console.log(date)
    let realDate: Date;
    const dd: number = Number(date.substring(0, 2))
    let n: number = Number(date.substring(3, 5))
    const mm: number = Number(n - 1)
    const yy: number = Number(date.substring(6))
    realDate = new Date(yy, mm, dd)
    return realDate
  }

  formatValue (value: string) {
    let formatedValue: string
    let returnValue: number = 0

    formatedValue = value.replace("R$", "").replace(",", ".")
    returnValue = Number(formatedValue)

    return returnValue
  }

  formatAnnuity (stringValue: string) {
    if (stringValue.trim().length == 0) {
      return 0
    } else {
      return Number(stringValue.trim())
    }
  }

  formatRepost (stringValue: string) {
    let returnValue: boolean = false;

    if (stringValue.toUpperCase() === 'SIM') {
      returnValue = true
    }

    return returnValue
  }

  __changeOrders () {

    let array: any[] = this.get2004()
    let count: number = 0

    array.forEach((item)=>{

      let dt: Date = new Date(item.data.payment_date)

      this.db.collection('sbccv_orders').doc(item.id)
      .set({ 'date': dt, 'payment_date': dt }, {'merge': true})
      .then(()=>{
        console.log(item.id)
        console.log(dt)
        count++
        console.log('------------------- ' +  count)
      })
      .catch((err)=>{
        console.log("ERR: " + err.message)
      })

    })

  }


get2004() {
  return  [{
    "id": "0AjZNgcySaMUmeAC1MVY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-01T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "18981199893",
      "member_cpf": "87002779753",
      "member_email": "rmustafa@cardiol.br",
      "member_id": "BnasZRhBSek8p7x03Rnl",
      "member_name": "Ricardo Migliorini Mustafá",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-01T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.35,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.35
    }
  }, {
    "id": "0FBivr8Cnun6QNZ8wSSF",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "92999971761",
      "member_cpf": "05256674234",
      "member_email": "regimoura1@hotmail.com",
      "member_id": "yoyhcVN0wp18n2knu88d",
      "member_name": "Fausto Vieira Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "0GAJUBAqvbnU02IkJTIC",
    "data": {
      "Tid": "8041402",
      "authorizationCode": "8041402",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "96981210106",
      "member_cpf": "40250350220",
      "member_email": "drfurlanprefeito@gmail.com",
      "member_id": "kcQhOV17lfFT1jYflY1t",
      "member_name": "Antonio Paulo de Oliveira Furlan",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "8041402",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "0HIONNcoDtVcbmCLL4rh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-02-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "01137255232",
      "member_email": "jbeneyto@cardiol.br",
      "member_id": "6zLZeOGqyVMDtpjGSUiz",
      "member_name": "Juan Vila Beneyto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "0MlYvIzo7XTGRrVGnoXA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51981260879",
      "member_cpf": "46464476572",
      "member_email": "plmoreno21@hotmail.com",
      "member_id": "td9hNzndz6vB885NeAIa",
      "member_name": "Paulo Lavaniere de Azevedo Moreno",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "0aLAshHCPfaZQTv9kZBh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999844079",
      "member_cpf": "73267627672",
      "member_email": "leo-ferber@hotmail.com",
      "member_id": "971Ou8wxjWV2HCw7LfyV",
      "member_name": "Leonardo Ferber Drumond",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "0hiWygvwE4Sq29dVdBHg",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-10-21T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991122410",
      "member_cpf": "58521623020",
      "member_email": "stevankrieger@cardiol.br",
      "member_id": "D1mBDeta1utrCCtdhGBu",
      "member_name": "Stêvan Krieger Martins",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-10-21T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 326.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 326.68
    }
  }, {
    "id": "0iy2Hx164FHbeJdMQGEu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "12991214400",
      "member_cpf": "05568802858",
      "member_email": "japiotto@uol.com.br",
      "member_id": "gvyFVzY81Rn4ctaNKwTw",
      "member_name": "José Alexandre Bazan Piotto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "0nZRND4AmnGSE3sT0GTS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71988881060",
      "member_cpf": "86036300549",
      "member_email": "brunorochaccv@hotmail.com",
      "member_id": "IhkEw3DWE01hzwAJyxuR",
      "member_name": "Bruno da Costa Rocha",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "0t79t7YcknFLYU3pLMBA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2006-03-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1199718483",
      "member_cpf": "52492966887",
      "member_email": "ronaldofontes09@gmail.com",
      "member_id": "nS0vd5AQhakvdeIEI2Bl",
      "member_name": "Ronaldo Ducceschi Fontes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "0zOJv2DbBdtSpWoPdqD7",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-05-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62981419480",
      "member_cpf": "35520990182",
      "member_email": "duiliorezende@uol.com.br",
      "member_id": "RZIHZOLKiV80nMcGtVVL",
      "member_name": "Duilio Rezende",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-05-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "1IBgMC0VHMmJNAWdhOdX",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14981111181",
      "member_cpf": "78215374700",
      "member_email": "kanimkassab1963@gmail.com",
      "member_id": "IN5pnKHGuCewCoeIonGz",
      "member_name": "Kanim Kalil Kassab",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "1Ma1KhZuHLiHS0onebGK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "45991077197",
      "member_cpf": "40137279949",
      "member_email": "ruimsalmeida@uol.com.br",
      "member_id": "pHopGlaMmGboS9s4ZJPk",
      "member_name": "Rui Manuel de Sousa Sequeira Antunes de Almeida",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "1Yo6ulGZbU4r7V7UrrbM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(11) 3251-5721 ",
      "member_cpf": "00334946816",
      "member_email": "blinck@uol.com.br",
      "member_id": "pjnshO6Q3rxRJvrUa52e",
      "member_name": "Marcos Fassheber Berlinck",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "1cBPEHJff27xld2jNLa9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21992786220",
      "member_cpf": "12593567791",
      "member_email": "walter.labanca.arantes@gmail.com",
      "member_id": "lNTsRdKMGiTncYsVGZP2",
      "member_name": "Walter Labanca Arantes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "1hlVEVd8Kh1GlY7h9nWO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1195285311",
      "member_cpf": "75594951687",
      "member_email": "",
      "member_id": "F3ccz7aURTcVQ9Iuv73u",
      "member_name": "Wesley Ferreira de Araujo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "1hqWi2bzLfekG00bX4qL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31984662021",
      "member_cpf": "65885830606",
      "member_email": "marconiruas@yahoo.com",
      "member_id": "YJDTGZgB3erkSjQsEwGH",
      "member_name": "Marconi de Oliveira Ruas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "1mSfkY6rG5DCegHGJxR8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999826611",
      "member_cpf": "26854295653",
      "member_email": "joafer13@gmail.com",
      "member_id": "KADLhWa8QcBdfcnWStm7",
      "member_name": "José Augusto Ferreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "20OcCqGo3BMvVzLDccSK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6199816612",
      "member_cpf": "40811131653",
      "member_email": "dr.carlosportilho@gmail.com",
      "member_id": "06HcpZPSj4CCxuniYTD7",
      "member_name": "Carlos Ferreira Portilho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 300,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 300
    }
  }, {
    "id": "20qoZXMnUXGyG5kUAADJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1199877915",
      "member_cpf": "00511180845",
      "member_email": "",
      "member_id": "9RGpUY19AWo0S0oL0GD4",
      "member_name": "Jose Luiz Dancini",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 106.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 106.67
    }
  }, {
    "id": "25Yfo44U4AIhPQSaI4IY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999992643",
      "member_cpf": "68810342704",
      "member_email": "paesleme@hucff.ufrj.br",
      "member_id": "dzKLi1kcJnITqT121rO9",
      "member_name": "Mauro Paes Leme de Sá",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "2KX3xMPO9tDJAFd2VZag",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31992963612",
      "member_cpf": "20131437615",
      "member_email": "fernandoafantini@gmail.com",
      "member_id": "RYDKllEwxDZR8rGlgksq",
      "member_name": "Fernando Antonio Fantini",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "2LL42rJsiiKNTqJZL5We",
    "data": {
      "Tid": "9121321",
      "authorizationCode": "9121321",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2012-09-21T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "34999798405",
      "member_cpf": "84900733687",
      "member_email": "claudiorcunha@gmail.com",
      "member_id": "tGM1aqUe9xjPkuPdGO5Q",
      "member_name": "Cláudio Ribeiro da Cunha",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "9121321",
      "payment_date": "2012-09-21T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "2MZdgEdwIgIUJjVs19Nq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-06-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71981136941",
      "member_cpf": "43123953068",
      "member_email": "sidneinardeli@cardiotorax.com.br",
      "member_id": "IUVEz9H7JXBih63n5n9g",
      "member_name": "Sidnei Pacciulli Nardeli",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-06-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "2RLmK6y2FCeCNchsRkSU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11942070416",
      "member_cpf": "25792906807",
      "member_email": "rarnoni@uol.com.br",
      "member_id": "8Map0XjSF9QFrEjbJ8Uj",
      "member_name": "Renato Tambellini Arnoni",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 401.42,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 401.42
    }
  }, {
    "id": "2U8hStlfIMlEcplRjtyi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11981753397",
      "member_cpf": "16425476893",
      "member_email": "aocampo1958@hotmail.com",
      "member_id": "big4Dp8apjLbAlIbDOyK",
      "member_name": "Alberto Ocampo Macedo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "2Z6Nce9jstwlaGx65wTR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-10-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61991197612",
      "member_cpf": "88152170704",
      "member_email": "marcus.cardiopace@gmail.com",
      "member_id": "UFDN6jIrA9ZGdcPxE5aa",
      "member_name": "Marcus Vinicius Nascimento Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-10-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "2fTcoNk4QTK9mxRIfb20",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-04-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6299092151",
      "member_cpf": "59158743804",
      "member_email": "wilsonmendoncajunior@bol.com.br",
      "member_id": "uSBECvSweNj6BUu5ky44",
      "member_name": "Wilson Mendonça Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 310.16,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 310.16
    }
  }, {
    "id": "2jXQahow8vgARWWgj3Lw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31984559099",
      "member_cpf": "57960674604",
      "member_email": "giancarlo.grossi@hotmail.com",
      "member_id": "RdK6oS1vHDDWV3PnXR28",
      "member_name": "Giancarlo Grossi Mota",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "2v5OCMRSneZBybfJa0A9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-06-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999827638",
      "member_cpf": "24258547034",
      "member_email": "fpeixotoliveira@bol.com.br",
      "member_id": "lbYRL7S7sfMs5XYmUn6C",
      "member_name": "Flávio Peixoto de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-06-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "3RRFg70VS0TX0wH9s8ON",
    "data": {
      "Tid": "712081",
      "authorizationCode": "712081",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17981150976",
      "member_cpf": "01172786887",
      "member_email": "domingo@braile.com.br",
      "member_id": "eioZXH6PDPMJHjanJJVV",
      "member_name": "Domingo Marcolino Braile",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "712081",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "3WBDl3OePvoHJ6X8QojP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991049122",
      "member_cpf": "66110688800",
      "member_email": "rbeyruti@usp.br",
      "member_id": "CZuxQOd65PbEzRLSClaQ",
      "member_name": "Ricardo Beyruti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "3ZDy0HDp3IWM4cBGD01L",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-04-13T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71981076948",
      "member_cpf": "14216760953",
      "member_email": "rickeloy.re@gmail.com",
      "member_id": "2pNWvS8bMLSSIkc6Cptx",
      "member_name": "Ricardo Eloy Pereira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-13T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "3dAANlwZ9V3rOW2U91sH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982639696",
      "member_cpf": "02878003853",
      "member_email": "stolf@incor.usp.br",
      "member_id": "0qhPHbRIIKFp5Na5NXvN",
      "member_name": "Noedir Antonio Groppo Stolf",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "3ryPTNgaTTZUX0jPqNal",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-03-29T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "53999822616",
      "member_cpf": "32658907400",
      "member_email": "odilson.sul@terra.com.br",
      "member_id": "ukGl91fLEjzd6wi19Qdn",
      "member_name": "Odilson Barbosa E Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-29T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "3smTGGipOA9zWpupqDxh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999945298",
      "member_cpf": "83915419915",
      "member_email": "eduardoadam@hotmail.com",
      "member_id": "lKXrCxQeyOBXld9f6MAD",
      "member_name": "Eduardo Pradi Adam",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "43bfuaBqHpoKHIpWlGc6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-07-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999823001",
      "member_cpf": "20328575372",
      "member_email": "aguiar.marco62@gmail.com",
      "member_id": "U9tEEDwHp6BXRrbW3ojE",
      "member_name": "Marco Aurélio Barroso Aguiar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-07-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.1,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.1
    }
  }, {
    "id": "4CAgqGO9PY2nN4CUrq2I",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85998374403",
      "member_cpf": "31497063353",
      "member_email": "aloisiogondim@hotmail.com",
      "member_id": "WXQAxuWb6h8uImxQF4MV",
      "member_name": "Aloísio Sales Barbosa Gondim",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "4DSX42vlN72WTnBYOAzS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999912147",
      "member_cpf": "36192937915",
      "member_email": "americo.cardio@uol.com.br",
      "member_id": "I5Wc7m73P4BNm5Vg6JKn",
      "member_name": "Américo Álvaro Farinha Martins",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "4QiESNKqcqVrv4msLcZ5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "33988998614",
      "member_cpf": "79047734734",
      "member_email": "lucenaesteves@gmail.com",
      "member_id": "8rz4VQREy5VbaF9e80xt",
      "member_name": "Evando Esteves de Lucena",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "4ieDijUhHMz2adlcBsmP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51 9939-0697",
      "member_cpf": "43432450044",
      "member_email": "r18pianta@gmail.com",
      "member_id": "1AMQ94bcwObOgkLVEWLR",
      "member_name": "Ricardo Medeiros Piantá",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 380.02,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 380.02
    }
  }, {
    "id": "4kFwjBM22CRngGswGF3W",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21991298599",
      "member_cpf": "60053828704",
      "member_email": "linofrancisco@gmail.com",
      "member_id": "ay4YKeucmrSR4LjUwXe6",
      "member_name": "Francisco José Saraiva Lino",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "4nidRFyYLnPbs2ENmFsk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "69981288700",
      "member_cpf": "35511729949",
      "member_email": "arleto@uol.com.br",
      "member_id": "BW32rYvNmMI5nr72en8u",
      "member_name": "Arleto Zacarias Silva Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "4xDXSEOrbIEbIDtLB3EH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2008-07-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999817920",
      "member_cpf": "14142449087",
      "member_email": "jaceratti551@gmail.com",
      "member_id": "RMcoizDXtjSyoyobtbUD",
      "member_name": "José Airton Barão Ceratti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-07-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "50pGKLSyyp7fOuK0yRtE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21998892730",
      "member_cpf": "26865246772",
      "member_email": "ernestokchavez@gmail.com",
      "member_id": "vB6AS6qikUIkpb7iWGYS",
      "member_name": "Ernesto Koehler Chavez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "51heYlkei6dZb2KANDvv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-11-30T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999722983",
      "member_cpf": "32258259991",
      "member_email": "luizfmachadocpa@hotmail.com",
      "member_id": "QoFsIoDYEaoctZdQ6EyZ",
      "member_name": "Luiz Fernando Machado",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-30T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.6
    }
  }, {
    "id": "53gJhKUIgFfPTkNq5NhU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83999821092",
      "member_cpf": "08272883449",
      "member_email": "ogoliveira3@uol.com.br",
      "member_id": "1y1VUQIL1Kujr6eGgQ10",
      "member_name": "Orlando Gomes de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "545ZRQPWXbTxROeVp75P",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "15997781385",
      "member_cpf": "14477134860",
      "member_email": "jafsampaio@uol.com.br",
      "member_id": "m0XcMq9B7rygNYmGXeBc",
      "member_name": "João Augusto Ferraz Sampaio",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "58wjp7hub3GLIJcb86nB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67992519803",
      "member_cpf": "59553200168",
      "member_email": "ccardiac@hotmail.com",
      "member_id": "U2wbHAmJXf0jd4fXWcVd",
      "member_name": "Mário Florizel Almeida de Araújo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 300,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 300
    }
  }, {
    "id": "59PgaDv40ybACIqmSB2L",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "09765360800",
      "member_email": "asabinom@cardiol.br",
      "member_id": "GXtKnrbPx4lCqOSAqFzI",
      "member_name": "Antonio Sabino de Mira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "5F7WTQymQGUd4OpVorq8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-04-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999023279",
      "member_cpf": "29722365800",
      "member_email": "ricardofamelo@uol.com.br",
      "member_id": "slTMPQ2dn6HM6YCXf3Ej",
      "member_name": "Ricardo Fernandes de Azevedo Melo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "5NSwFh94JrHkkgDFwgBB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "79988191085",
      "member_cpf": "13824635534",
      "member_email": "mrc-777@uol.com.br",
      "member_id": "Iu8kcxTPHZujbr3kRKEY",
      "member_name": "Marcos Ramos Carvalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "5OtPT94yuQCJ5366FkVJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-02-25T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41984177188",
      "member_cpf": "76638448900",
      "member_email": "guaritasouzalc@hotmail.com",
      "member_id": "FRzlOKNtOMe6wHJxdSHV",
      "member_name": "Luiz César Guarita Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-25T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "5RpKWPVXWpFCzwbBr1Jv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-06-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "82991093637",
      "member_cpf": "51700824449",
      "member_email": "eoloribeiro@yahoo.com.br",
      "member_id": "Gb1f8gFOJjJzt6MfErjp",
      "member_name": "Eôlo Ribeiro de Alencar Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-06-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "5WjjuFRQYFp9IKtn1BXH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86999883708",
      "member_cpf": "31995659304",
      "member_email": "rbarrosaraujojr@gmail.com",
      "member_id": "GEOJ5NVoSmpwjWzvJwT5",
      "member_name": "Raimundo de Barros Araújo Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.93
    }
  }, {
    "id": "5bYeA9pcKvtxQ08cfKNi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-09-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999464045",
      "member_cpf": "18685919991",
      "member_email": "edisonjribeiro@hotmail.com",
      "member_id": "cMOt86uUkHp76jZcspco",
      "member_name": "Edison José Ribeiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 484.29,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 484.29
    }
  }, {
    "id": "5btdhhXq7kyLsCD6SYaN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1196867535",
      "member_cpf": "07706373886",
      "member_email": "gerola@uol.com.br",
      "member_id": "LqDcdBcMomv3icuCrlCA",
      "member_name": "Luis Roberto Gerola",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "5eZ3uoTAfC4dFW4OAAmq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2006-03-29T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999354038",
      "member_cpf": "00169853896",
      "member_email": "joao.nelson@terra.com.br",
      "member_id": "UZ4gF3qx00SMADbN1fSH",
      "member_name": "João Nelson Rodrigues Branco",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-29T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "5g9zuQqHpGQX7NQqbSEn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999836852",
      "member_cpf": "53892518653",
      "member_email": "haroldoferraz@hotmail.com",
      "member_id": "ZTXmnm0ahUM6C6nmiuJC",
      "member_name": "Haroldo Adans Ferraz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "5iuHkq3HBZrgWaZUg67P",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996521562",
      "member_cpf": "69485518668",
      "member_email": "petronio@sbccv.org.br",
      "member_id": "2UgsX4q6yvhqrUWD8ziy",
      "member_name": "Petrônio Generoso Thomaz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "5qVwXJ1GAPIjoCXNrrr0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2009-02-12T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999474069",
      "member_cpf": "12191663087",
      "member_email": "guaracyf@terra.com.br",
      "member_id": "ftfMFddhDskLegRAScNK",
      "member_name": "Guaracy Fernandes Teixeira Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2009-02-12T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "5uRQlrzMbZLOayFyPAHu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "84991262966",
      "member_cpf": "13317970472",
      "member_email": "marcelocascudo@me.com",
      "member_id": "9lMeTcTxlqNY7HCQnI4J",
      "member_name": "Marcelo Matos Cascudo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "613mX66oKwkfLrak9v58",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "28999454045",
      "member_cpf": "37672649787",
      "member_email": "ldtorres@uol.com.br",
      "member_id": "IdQi9kA42hEaIdKZZMCn",
      "member_name": "Luiz Daniel de Fraga Torres",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "62i7R71Y33bLDbEPvQyi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-03-04T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "82999821825",
      "member_cpf": "48356816491",
      "member_email": "alfredoamrosa.68@gmail.com",
      "member_id": "5EZnaBiWZ1BkKmoaqcnp",
      "member_name": "Alfredo Aurélio Marinho Rosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-04T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.6
    }
  }, {
    "id": "65jSKxncPEa9125SXTYk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-05-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999971010",
      "member_cpf": "06757880130",
      "member_email": "adelioleite@cardiol.br",
      "member_id": "1IvZyjmjbkkxBPoQI3mS",
      "member_name": "Adélio Ferreira Leite",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-05-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "6HPGuQk3B2OwleJi9AFh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999718534",
      "member_cpf": "06843514120",
      "member_email": "odilon.barbosa.47@gmail.com",
      "member_id": "oidwrXhtswEYWHL5LMh9",
      "member_name": "Odilon Nogueira Barbosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "6HVhcq5LKPnjwIRL8Azx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999811712",
      "member_cpf": "27851656672",
      "member_email": "renato_rabello@yahoo.com.br",
      "member_id": "6TpoHxZg0ZFY8ngpngod",
      "member_name": "Renato Rocha Rabello",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "6Hx5cCZzqwTLNnKKCMJP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11994572658",
      "member_cpf": "59898186887",
      "member_email": "rossiniiglezias@uol.com.br",
      "member_id": "hMXmx67yD0R7SrTKvxoy",
      "member_name": "José Carlos Rossini Iglezias",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "6YTC3ro6bGS0utpIaHUU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62984113100",
      "member_cpf": "37511815120",
      "member_email": "jngsiqueira@gmail.com",
      "member_id": "gdJkLnRf3tdFoqRe5qxG",
      "member_name": "João Nicolau Gomes de Siqueira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "6Yzxpo09y0rGXhMD7DSV",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999817890",
      "member_cpf": "33791546449",
      "member_email": "haroldobbarroso@yahoo.com.br",
      "member_id": "wM5hLMlMiGfe1WM6AEqj",
      "member_name": "Haroldo Brasil Barroso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "6sKKaaOBWDJnXYBm2pyg",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-04-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999041951",
      "member_cpf": "06090613304",
      "member_email": "dario.frota@gmail.com",
      "member_id": "XiW8Y94tEbQ5Bp7ZPtvD",
      "member_name": "José Dario Frota Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 572.29,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 572.29
    }
  }, {
    "id": "6yTB0ZvA07ZJ4Ekz64Xf",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "7199622091",
      "member_cpf": "00203181549",
      "member_email": "jehocarv@gmail.com",
      "member_id": "Sz1buzq38zUDuxgI67sn",
      "member_name": "Jehorvan Lisboa Carvalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "75jhun2CnwuNw6yReLTM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999541410",
      "member_cpf": "00091464072",
      "member_email": "jjgoldani@terra.com.br",
      "member_id": "UOC2Y8YrnI7gJ1cwPy2A",
      "member_name": "Juremir Joao Goldani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "788w8JPt4SVYCbkbzViI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2013-04-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999766852",
      "member_cpf": "06295303862",
      "member_email": "silviocoutinho@ig.com.br",
      "member_id": "c5u7HmutCfSd0gRaGoyc",
      "member_name": "Silvio Luiz de Jesus Coutinho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2013-04-18T03:00:00.000Z",
      "payment_type": "Cartão de Crédito",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Cartão de Crédito",
      "value": 400
    }
  }, {
    "id": "7DvqWG8y6bqsEWS3ItQA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999764053",
      "member_cpf": "26188732620",
      "member_email": "jfbaumgratz@hotmail.com",
      "member_id": "kJHdsSp2a02kOkV5aJFh",
      "member_name": "José Francisco Baumgratz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 468.7,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 468.7
    }
  }, {
    "id": "7Hm3dBY61TDgkdegYGfY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999825679",
      "member_cpf": "91618347772",
      "member_email": "lucioguarconi@hotmail.com",
      "member_id": "loZfZrsD8j2k8VgJNZ0I",
      "member_name": "Lúcio Pereira Guarçoni Duarte",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "7cRYbRY0bUT9wv8XMEt5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999798098",
      "member_cpf": "00914013807",
      "member_email": "valpelisser@terra.com.br",
      "member_id": "Z8uiF2pLISUKj38hBtiT",
      "member_name": "Valquíria Pelisser Campagnucci",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "7cp8d6XzBkE8oKc79nYT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999724443",
      "member_cpf": "08021198915",
      "member_email": "fabiosallum25@gmail.com",
      "member_id": "eaRJ0qJJfpVBpO8J44Sz",
      "member_name": "Fábio Said Sallum",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "7eOsmmaLiATQywBTGM2V",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "5198078127",
      "member_cpf": "00153257091",
      "member_email": "blaufsouza@gmail.com",
      "member_id": "rQcxdqNsUEXKxKRmJYDg",
      "member_name": "Blau Fabricio de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "7idszmu5vjO3DWE7sccJ",
    "data": {
      "Tid": "1217",
      "authorizationCode": "1217",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-09-01T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999757310",
      "member_cpf": "01229648704",
      "member_email": "jdeus313@gmail.com",
      "member_id": "7FLH4vrgMY4JKeGL4pUy",
      "member_name": "João de Deus E Brito",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "1217",
      "payment_date": "2004-09-01T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 252.26,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 252.26
    }
  }, {
    "id": "8074eAdeYSLEKhszpmfM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00427845815",
      "member_email": "ajatene@hcor.com.br",
      "member_id": "bs1cXXTlKSJNo3dZgDJb",
      "member_name": "Adib Domingos Jatene",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "871OZ5gQkrATQ6zDE9K6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-02-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41991299999",
      "member_cpf": "59974150906",
      "member_email": "leonardo@mulinari.med.br",
      "member_id": "tj9cMw3YsHNv5FU6MWk3",
      "member_name": "Leonardo Andrade Mulinari",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "87EEAHMB72aNTpZXaNMZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "55999646140",
      "member_cpf": "67346235053",
      "member_email": "ralf22662@gmail.com",
      "member_id": "cVRfg3F6lBbBzK8swi8S",
      "member_name": "Ralf Stuermer",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "88TZbkMtf0Wwyj4CU4aU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19996055352",
      "member_cpf": "50946471134",
      "member_email": "lindembergms@uol.com.br",
      "member_id": "3bhZkOCLuxniVidmRnQ4",
      "member_name": "Lindemberg da Mota Silveira Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "8KKTURUgomzL8ZzeBV0N",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-26T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67992922015",
      "member_cpf": "13227262487",
      "member_email": "jlfvasco@gmail.com",
      "member_id": "BEsEMftbEMsBia1IWwhG",
      "member_name": "Jorge Luiz Franca de Vasconcelos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-26T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "8Z0Ju1TT65jS9rPHhVb4",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-01T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "13828924620",
      "member_email": "",
      "member_id": "NuOejlfNskZgkpRYjEop",
      "member_name": "Dilmon Resende Buzatti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-01T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "8g7WmzlawJsWj64nN10t",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991585067",
      "member_cpf": "00610496891",
      "member_email": "mgcardio@uol.com.br",
      "member_id": "3XbkLPB7ZsxYxq3ZbnDu",
      "member_name": "Maurício Galantier",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 572.29,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 572.29
    }
  }, {
    "id": "8jDowdL4zmIT2wllWkIy",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-02-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999917389",
      "member_cpf": "60637420934",
      "member_email": "ccg.giffhorn@gmail.com",
      "member_id": "ReplF0KW7kALHES2bBLA",
      "member_name": "Helcio Giffhorn",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "8pEarHaDYEjJSwzlXma3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "32999875120",
      "member_cpf": "26485060715",
      "member_email": "phcpassos@hotmail.com",
      "member_id": "NBIGrScGK4MeVhscEkmq",
      "member_name": "Pedro Horácio Cosenza Passos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "8qIJ5vlkpp7NDEpgEwyY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(73) 99948-1102",
      "member_cpf": "47358319672",
      "member_email": "vismario@hotmail.com",
      "member_id": "HBi2Aza6zfd7eKgxPvqP",
      "member_name": "Vismário Camargo de Freitas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "8rzxoCaOnx9lHpslPWqt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00085574899",
      "member_email": "gardiencorcm@uol.com.br",
      "member_id": "cBcEdFTFOIZh6N6SDLD7",
      "member_name": "Michel Toufik Awad",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "8ugk8qNymdPkoVg4JECe",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999317167",
      "member_cpf": "66506905891",
      "member_email": "dcidallan@incor.usp.br",
      "member_id": "PDtHWlJLii7Wih1rIqmx",
      "member_name": "Luís Alberto Oliveira Dallan",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "8v8RD4MyIDTJZ6u01pQF",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11985859034",
      "member_cpf": "21217327649",
      "member_email": "cardiopsallum@terra.com.br",
      "member_id": "6drpnElqcLwu08THSgxp",
      "member_name": "Paulo Márcio Sallum",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "91q0wPKa6Ct5MIFA7DnN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "55999028878",
      "member_cpf": "60860120830",
      "member_email": "snunes@cardiol.br",
      "member_id": "1s63VINKPpYzVvSFyvCd",
      "member_name": "Sérgio Nunes Pereira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "97L9xuB32dA3JLVt18QY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3199535299",
      "member_cpf": "19563736672",
      "member_email": "priminout@yahoo.com.br",
      "member_id": "KpJOKRZ8EUZl5qb0jm1E",
      "member_name": "Luiz Fernando Caetano Machado",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "97iTVG0M29THtSeyUR9p",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83999816776",
      "member_cpf": "49896849404",
      "member_email": "maurilio.od@gmail.com",
      "member_id": "wQvCDxqKx3hrExuXNGmz",
      "member_name": "Maurílio Onofre Deininger",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "9AEE0H6fk11J20n1fDOg",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2007-04-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67999813007",
      "member_cpf": "10534742882",
      "member_email": "ocampos.sergio@hotmail.com",
      "member_id": "lmytuV8uSyscn22yAcgm",
      "member_name": "Sérgio Ricardo Ocampos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 300,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 300
    }
  }, {
    "id": "9KCtBH2GFCBebe0AC0Pf",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85988976170",
      "member_cpf": "05225027334",
      "member_email": "c.m.emanuel@gmail.com",
      "member_id": "ZSWpUKVcL4RyEEBauubp",
      "member_name": "Emanuel de Carvalho Melo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "9Lqb0SQGObUvczl42h5O",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "46991018475",
      "member_cpf": "83251871900",
      "member_email": "rlwolker@hotmail.com",
      "member_id": "CyrYi4XH3TUnIR9994L8",
      "member_name": "Rinaldo Luiz Wolker",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "9T0jdQRfnWBtZwEHxq9y",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999997582",
      "member_cpf": "01035830841",
      "member_email": "richterivo123@gmail.com",
      "member_id": "BvRSfinA6QkKR3NBFXBf",
      "member_name": "Ivo Richter",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "9fG1jkyGNXCXyhQjUBYv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31991737972",
      "member_cpf": "19884664820",
      "member_email": "ccv@santacasabh.org.br",
      "member_id": "HUD5HSFWAAEmVp2CfJBW",
      "member_name": "João Alfredo de Paula E Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "9hTsyq3d4un5NiRdcfSC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991139040",
      "member_cpf": "33196192849",
      "member_email": "nilzoribeiro@terra.com.br",
      "member_id": "1wScgaMd0FFCtXeKnGeF",
      "member_name": "Nilzo Augusto Mendes Ribeiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "A7E4d69TtH71iJ5PV0rc",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999235641",
      "member_cpf": "11129506720",
      "member_email": "nikiniki_115@hotmail.com",
      "member_id": "ykBJw31Tzxfo6vKcwZ3E",
      "member_name": "Paulo Rodrigues da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "A9C3QLfBJ3pcL4zhtrNR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31987611145",
      "member_cpf": "48604526668",
      "member_email": "mpborem@cardiol.br",
      "member_id": "biZsvTpcm4MjBe3TRNKu",
      "member_name": "Marcelo Pimenta Borem",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "AcSR6sn7mkCKiHsSMzEi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999735374",
      "member_cpf": "01469355787",
      "member_email": "schariff2@gmail.com",
      "member_id": "cAV1Kx66jusYlX9lmman",
      "member_name": "Schariff Moysés",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "AnbcQaVDYAZ8ABFLWTHl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21967360637",
      "member_cpf": "95928669704",
      "member_email": "amlopes@terra.com.br",
      "member_id": "BmpyLISfCBDnR0bJ6omA",
      "member_name": "Andrea Mazoni Lopes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.61
    }
  }, {
    "id": "AoYfHGE8ESi6NuyYvRGP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00274895153",
      "member_email": "",
      "member_id": "y3kqwiDSQOatlTgS4A8H",
      "member_name": "Olair Alves de Queiroz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "AraO5Y1dc9iun71WBmQw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2013-05-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999888092",
      "member_cpf": "70721459749",
      "member_email": "m.cris.a@terra.com.br",
      "member_id": "cNT1eaPi7LBzy7rf9J6z",
      "member_name": "Panayotis Georges Agorianitis",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2013-05-16T03:00:00.000Z",
      "payment_type": "PIX/Transferência",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 375,
      "total_minus_tax": 0,
      "type": "PIX/Transferência",
      "value": 375
    }
  }, {
    "id": "B5ZU0upVC7gkGZTOiuis",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-09-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999028316",
      "member_cpf": "58692991104",
      "member_email": "pattymarques@yahoo.com",
      "member_id": "8aTzXBSRggPCd8myNKXq",
      "member_name": "Patrícia Marques de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 320,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 320
    }
  }, {
    "id": "B5s6DMTXIYcC1znjCN7q",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "98991162595",
      "member_cpf": "10704698315",
      "member_email": "molina_orb@yahoo.com.br",
      "member_id": "rzjVKZzZnFsDCby8mgzb",
      "member_name": "Oscar Reynaldo Molina Benitez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "B7g95BzJNINXRp4c1S05",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86988043888",
      "member_cpf": "27468453349",
      "member_email": "dibfilho@outlook.com",
      "member_id": "KftmAjOzBOQKfoQzF1FK",
      "member_name": "Antonio Dib Tajra Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 106.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 106.67
    }
  }, {
    "id": "BFUk2pAQPFUpn5wyu8Gd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2007-04-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "4399911755",
      "member_cpf": "43455565972",
      "member_email": "circardiaca@sercomtel.com.br",
      "member_id": "51L6g5BR9ccHn9p3mYlH",
      "member_name": "Celso Otaviano Cordeiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "BPqHn6i1qI5IPrslLaUQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19997816868",
      "member_cpf": "08352017837",
      "member_email": "lfcoimbra@yahoo.com.br",
      "member_id": "Tccv45OmiqVOe12bC7Mj",
      "member_name": "Luiz Fernando Coimbra",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "BUXKGY4xoRiRVWbGDrtF",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2008-04-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999724854",
      "member_cpf": "24232050663",
      "member_email": "divinofpinto@yahoo.com.br",
      "member_id": "qH8TRPCnJaqHhEW9dHo8",
      "member_name": "Divino Francisco Pinto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-04-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 700,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 700
    }
  }, {
    "id": "BiKqZw0ZnJejFkbMG4b3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "54991224874",
      "member_cpf": "54389976087",
      "member_email": "c.sodre@terra.com.br",
      "member_id": "uqhfvGfAh2X1nRkXRkNv",
      "member_name": "Carlos Sodre Soares Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "Biy7Go0E9WNFPp2d6Cje",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67992935666",
      "member_cpf": "54322642187",
      "member_email": "cidaivo@terra.com.br",
      "member_id": "8iJ259rGjxyr8fmaRWUz",
      "member_name": "Aparecida Afif Elossais Villa Maior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 274.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 274.94
    }
  }, {
    "id": "BnQzrdTn6lTw7fdhMJRx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31987733312",
      "member_cpf": "37959794715",
      "member_email": "marcosvale@globo.com",
      "member_id": "sYcq05hqM8MwJ1ttjsdn",
      "member_name": "Marcos de Paula Vale",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "BsRSZJl3QQ2VZ9grKXbZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2008-10-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71982559424",
      "member_cpf": "13062131500",
      "member_email": "laudelinosfilho@hotmail.com",
      "member_id": "WX8SPV0VAA04XpVT1Syv",
      "member_name": "Laudelino de Sousa Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-10-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "C0yxTBOiuja2uigyPtLq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2009-03-26T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11983317731",
      "member_cpf": "13557153851",
      "member_email": "moise.dalva@gmail.com",
      "member_id": "wND09pr1l2gHAZxarKgR",
      "member_name": "Moise Dalva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2009-03-26T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "C7SLIFpZEU80ZX0GlTOZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "35988767652",
      "member_cpf": "68010540668",
      "member_email": "mauricioc.gomes@gmail.com",
      "member_id": "qRi45xv0uM68VRqTpULw",
      "member_name": "Maurício de Castro Gomes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "C9Ue2jP5XmXD3eoJAIIo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47991503127",
      "member_cpf": "50542893991",
      "member_email": "franzoni65@yahoo.com.br",
      "member_id": "efQmiOWrB4tA7CSzMkvX",
      "member_name": "Marcos Luiz Franzoni",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 390.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 390.94
    }
  }, {
    "id": "CCvy4p09Tt7WHw3OqcyY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2010-03-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996246518",
      "member_cpf": "17564921234",
      "member_email": "pedroedias@uol.com.br",
      "member_id": "nNSNDHhYxn9sgFvObRiH",
      "member_name": "José Pedro Esteves Dias",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2010-03-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "CLOkE4dkYOIirB8euOSh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999827981",
      "member_cpf": "62169300791",
      "member_email": "joseshenrique@bol.com.br",
      "member_id": "67Mbv5aXCtj1QS9KBYlW",
      "member_name": "José Silva Henrique",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "CMLFB6giDpbIVAKOKHSj",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "87192420697",
      "member_email": "grpenna@terra.com.br",
      "member_id": "cWHRQs5rxvDKm8XrVKpu",
      "member_name": "Geraldo de Rezende Pena",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "CQzz8hrTDchRexq2wVWL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31991059632",
      "member_cpf": "43567444620",
      "member_email": "sergiochristo@gmail.com",
      "member_id": "bj7oQ2fxfPdxktst0LvS",
      "member_name": "Sérgio Figueiredo Campos Christo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "CRKUq4PgAERikffU55g8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31988860888",
      "member_cpf": "40341062634",
      "member_email": "wamg0510@gmail.com",
      "member_id": "7jx3TfLiC7AkQ9NHTvda",
      "member_name": "Wellington Araújo Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "CVWOuiwTqyqlJsbuhlMs",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19997905667",
      "member_cpf": "11979184852",
      "member_email": "ferantoniali@uol.com.br",
      "member_id": "KGboPJaP8ub7mjron2Qe",
      "member_name": "Fernando Antoniali",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "CaVObvIBO8iMUIOns7fm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17997771697",
      "member_cpf": "73665614872",
      "member_email": "ardito@terra.com.br",
      "member_id": "PIQdHi4gVfur4BzudaOt",
      "member_name": "Roberto Vito Ardito",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Cgcq9uqDaKXgAt27qjtr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-07T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "28998854090",
      "member_cpf": "03455515754",
      "member_email": "agaltoe@gmail.com",
      "member_id": "tpvC9Vtn6GPh40BouejW",
      "member_name": "Alessandro Gonçalves Altoé",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-07T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "CjYYzAEP8lgN9xyElHRR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(14) 12523-4078",
      "member_cpf": "65075188672",
      "member_email": "dafonsecadasilval@upmc.edu",
      "member_id": "9Wur5mlBxqRBsiC0ZPdP",
      "member_name": "Luciana Fonseca da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "CobGGvX3rqAlVroluYaY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2007-04-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47999880339",
      "member_cpf": "74657020978",
      "member_email": "santoroitorax@hotmail.com",
      "member_id": "nogq5P5D7b3aSVHF6goW",
      "member_name": "Milton de Miranda Santoro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "CrNm4g94ZD8YDa2IpT0v",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21996098542",
      "member_cpf": "70161810730",
      "member_email": "ricardomiguelrio@gmail.com",
      "member_id": "8fMnEpRrboOOKgdzZb4a",
      "member_name": "Ricardo Miguel G. Carvalho Francisco",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "D4RrxvZizO8X50It734F",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11973342104",
      "member_cpf": "60055022120",
      "member_email": "franvidal@uol.com.br",
      "member_id": "G7Wgq4Sj38kqsZ2OVRtk",
      "member_name": "Francismar Vidal de Arruda Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "D5FwhQ9t2m5ku6jzLYxt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2005-03-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61992162288",
      "member_cpf": "22889914100",
      "member_email": "rochapaniagua@gmail.com",
      "member_id": "cjVsHRY5XvyWtwQUtJ7F",
      "member_name": "Pedro Rocha Paniagua",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.6
    }
  }, {
    "id": "D619epMudAtxolKxmnwm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2006-03-24T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999091211",
      "member_cpf": "30015952304",
      "member_email": "fabianojuca@gmail.com",
      "member_id": "znJNFvKTIqZMJkOXLTvz",
      "member_name": "Fabiano Gonçalves Jucá",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-24T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "DGLoEn7EZzns0cuio8lE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11981144748",
      "member_cpf": "05397879819",
      "member_email": "caneo@me.com",
      "member_id": "Grp7ZpLL5sbcfYJM0t21",
      "member_name": "Luiz Fernando Caneo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.61
    }
  }, {
    "id": "DMJJSId7T13pwCctAVEL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2006-07-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31988537171",
      "member_cpf": "29392934653",
      "member_email": "charlessimaofilho@gmail.com",
      "member_id": "7htNDzdl1GPxtUBaHuTu",
      "member_name": "Charles Simão Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-07-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "DN30MvrnyL1XGUcloU2R",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22988213940",
      "member_cpf": "17209579915",
      "member_email": "ronaldsouzapeixoto@terra.com.br",
      "member_id": "7Y8C1brhJbEgvu79rVUp",
      "member_name": "Ronald Souza Peixoto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "DgxlBgYl6mV6u9nkoLzT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "48999822512",
      "member_cpf": "34432400978",
      "member_email": "arampinelli1@gmail.com",
      "member_id": "uapgCKqWnADue7iuwSCm",
      "member_name": "Amandio Rampinelli",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.41,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.41
    }
  }, {
    "id": "DkmyRhee4uWD2VFwDL2o",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-01T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "35988990210",
      "member_cpf": "01038567653",
      "member_email": "eliaskallas@uol.com.br",
      "member_id": "w2FOStkDwJQYLGRSCFVi",
      "member_name": "Elias Kallás",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-01T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "DudzuLoyPt7w4oyGsIkf",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-02-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83999711363",
      "member_cpf": "23783257468",
      "member_email": "valdircdes@ig.com.br",
      "member_id": "LHKSOuP1kz5cCab2hqfy",
      "member_name": "Valdir Cesarino Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "E0rXhfxsRldEusviqWve",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "32999888332",
      "member_cpf": "23615702620",
      "member_email": "eloicolen@gmail.com",
      "member_id": "fgEwsLaGtJlsOqtOnaat",
      "member_name": "Eloi Colen Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "E8W5yopAQcsDWVFntXQz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "8699878757",
      "member_cpf": "23361867487",
      "member_email": "p.rego@uol.com.br",
      "member_id": "sBk2ulvCkPRPdk8svRLM",
      "member_name": "Paulo Rego Medeiros",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "E8mcqe2ScWgRiwDa7gJO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6199750885",
      "member_cpf": "05765080120",
      "member_email": "",
      "member_id": "mr4dLBztj8PiNTa2qwXu",
      "member_name": "Joao Guilherme Westin Duarte",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 258.92,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 258.92
    }
  }, {
    "id": "E9QDBXbLmkIMpxWffUVi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11992121665",
      "member_cpf": "75485389872",
      "member_email": "dr.paulo.chaccur@gmail.com",
      "member_id": "tdcgkmaT7RopEnIq7Zzl",
      "member_name": "Paulo Chaccur",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "E9aTwHKUgide8Q8AukAi",
    "data": {
      "Tid": "10041103",
      "authorizationCode": "10041103",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982028223",
      "member_cpf": "04183702810",
      "member_email": "fernandopatricioaliaga@gmail.com",
      "member_id": "1FOP7Zi0JdYEpDFFPM17",
      "member_name": "Fernando Patricio Aliaga Mora",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "10041103",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.6
    }
  }, {
    "id": "EKDe67YZ27eZar7sHWOr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-12-05T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1791556058",
      "member_cpf": "54045100806",
      "member_email": "walteranselmo@hotmail.com",
      "member_id": "E7nt2Lo2d1e6iRkfVl3s",
      "member_name": "Walter Anselmo Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-12-05T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 362.31,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 362.31
    }
  }, {
    "id": "EPJjQv0xoS0BeCM8Ju4b",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "48999824580",
      "member_cpf": "39930033904",
      "member_email": "drlbonatelli@gmail.com",
      "member_id": "tfuripbpQlYD1rUm0RvK",
      "member_name": "Lourival Bonatelli Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "EVLeoR0fKraeLK2k6u9x",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "42988124819",
      "member_cpf": "15854924854",
      "member_email": "freitasccv@gmail.com",
      "member_id": "0CfTrXlm2vtJq4OHjy0I",
      "member_name": "Marcelo Ferraz de Freitas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "EWjMGpEdyBSgJVfvkhZ6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999847171",
      "member_cpf": "08305331415",
      "member_email": "jesualdogp@yahoo.com.br",
      "member_id": "59vJkvm8kGnxIBfUhodR",
      "member_name": "Jesualdo Guedes Pereira Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.6
    }
  }, {
    "id": "EgRKsm8o6etCylFco8aQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999872174",
      "member_cpf": "00501395091",
      "member_email": "prprates@uol.com.br",
      "member_id": "LmU4Qtu1eKzjgpwIEjBg",
      "member_name": "Paulo Roberto Prates",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "EgTc1NS3MDPgEqWluEqo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16997865194",
      "member_cpf": "02164574834",
      "member_email": "clinicacecorp@ig.com.br",
      "member_id": "Vy9Zilsh0Dx4jULAqBB3",
      "member_name": "Paulo José de Freitas Ribeiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Eiu09ftSazDPfWMPzoKv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999729450",
      "member_cpf": "40305082949",
      "member_email": "incorcuritiba@incorcuritiba.com.br",
      "member_id": "L14lyaA2guegwmc8salH",
      "member_name": "Luiz Fernando Kubrusly",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "ElTdbOdhx4rVOkHBOoQK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982817722",
      "member_cpf": "37083589615",
      "member_email": "rsassad@cardiol.br",
      "member_id": "dSLHPzKH0oiuukq43W10",
      "member_name": "Renato Samy Assad",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "EqSVAm1pcyfqtPjQpbal",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(11) 3721-3962",
      "member_cpf": "03673249894",
      "member_email": "gilmargsantos@uol.com.br",
      "member_id": "uwxeXDisD1cHkPrZsHof",
      "member_name": "Gilmar Geraldo Dos Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "EsglFfIlPgJCUCWOT15I",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999854626",
      "member_cpf": "88794865868",
      "member_email": "dirceufaelli@uol.com.br",
      "member_id": "Ns6RWOpyz8XmfQC5FM2S",
      "member_name": "Dirceu Oscar Faelli Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "F8bG0wysSxrkqxh95kya",
    "data": {
      "Tid": "10041158",
      "authorizationCode": "10041158",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-03-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999820002",
      "member_cpf": "19739079849",
      "member_email": "dcimiguel@terra.com.br",
      "member_id": "5yruXyzx4lOFOiqBMOqz",
      "member_name": "Miguel Barbero Marcial",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "10041158",
      "payment_date": "2005-03-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "FGh9JJ5TBlqEqgE3SIgR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "24263125053",
      "member_email": "",
      "member_id": "Iu1IekSUXxOkyjAbz4jV",
      "member_name": "Nuno Fevereiro Ferreira de Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.61
    }
  }, {
    "id": "FO0zmzB5qzHWyZLD2wl9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-07-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "91345707800",
      "member_email": "fredericovas@hotmail.com",
      "member_id": "sK9N67NFikY93SUaK5Hj",
      "member_name": "Frederico Pires de V. Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-07-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "FRVqARwfWcZbISlsucAL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-07-29T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16997030887",
      "member_cpf": "49394959653",
      "member_email": "cosac.paranhos@gmail.com",
      "member_id": "QVuXA4cv83dSQNsvi4xF",
      "member_name": "Eduardo Cosac Paranhos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-07-29T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "FU3WPQ8kD41KZA2Tw1O5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999885019",
      "member_cpf": "52970620715",
      "member_email": "mario.coli.junqueira@globo.com",
      "member_id": "uFjh5dQOt45o08T5WqCD",
      "member_name": "Mário Coli Junqueira Moraes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "FietCrJ8gXt6jCHAd2rO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999196274",
      "member_cpf": "03855085811",
      "member_email": "lfpmoreira@uol.com.br",
      "member_id": "rjIyYCVbXWbl6dYcowSB",
      "member_name": "Luiz Felipe Pinho Moreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Fliqj4SkoG0vPNmq5gjB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-04-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67999616206",
      "member_cpf": "36721077191",
      "member_email": "theofilo@live.com",
      "member_id": "EPGJ8a4avtbf0Ou21RHO",
      "member_name": "Theófilo Gauze Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-04-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.61
    }
  }, {
    "id": "FuAGG7Sw8WD9SGAXRLwC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999830535",
      "member_cpf": "43086500387",
      "member_email": "lobomesquita@ig.com.br",
      "member_id": "AWoruns510uO8qD4qj8J",
      "member_name": "Roberto Augusto Carneiro de Mesquita Lobo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "FvH15FtyWl1y7xIO0l0z",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999690119",
      "member_cpf": "21491747668",
      "member_email": "jronaldojd@gmail.com",
      "member_id": "RuH8Y0ywVUq3pRpcsLmY",
      "member_name": "José Ronaldo Junqueira Dias",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "G0uADyO5zJQIedbKz8Bj",
    "data": {
      "Tid": "10041196",
      "authorizationCode": "10041196",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "31061806644",
      "member_email": "",
      "member_id": "MgYXf0LC1vBmFLdl8orw",
      "member_name": "Miguel Biondi Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "10041196",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 86.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 86.67
    }
  }, {
    "id": "G2kzMaYrqp1oHtLfkbJ9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "08567563852",
      "member_email": "",
      "member_id": "77x9KabA0rAIA3fSezXE",
      "member_name": "Francisco Roberto Martinez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "GFjbnEbUvQfyIhhD5vHm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-09-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19998640555",
      "member_cpf": "76309819887",
      "member_email": "francaster@gmail.com",
      "member_id": "XrIaOWa05WojgBjsOOwH",
      "member_name": "Luiz França Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-09-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "GQ8AS19pZiDasgwv5FaZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "H2AoWhktluQaWYuPydHC",
      "category_name": "Não Sócio",
      "date": "2007-04-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91981679885",
      "member_cpf": "24513750278",
      "member_email": "walcemirjunior@uol.com.br",
      "member_id": "Bs8vLoM9jb8GVPIhVyDU",
      "member_name": "Walcemir Aquino de Aragão Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "GQjE8N9S5XRnNLDusBeJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "55999759899",
      "member_cpf": "52494519004",
      "member_email": "gersonpo@terra.com.br",
      "member_id": "Xn5J7jelzf8kGP9CFb2o",
      "member_name": "Gerson Pereira de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "GYB5mWCUb3RWD1hdgogD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999901933",
      "member_cpf": "12777894876",
      "member_email": "silviaelisaa@yahoo.com.br",
      "member_id": "SKvUGt3uZCdEAXYri7ZJ",
      "member_name": "Salomon Soriano Ordinola Rojas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "GYu4ThWM1pv9XfSyUavu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-04T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83991219296",
      "member_cpf": "36616630544",
      "member_email": "marcelo_gag@hotmail.com",
      "member_id": "hQroTPyy01X2ULkfeV1k",
      "member_name": "Marcelo Gentil Almeida Guedes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-04T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "GdrorOo5V5KP1GgS1VBQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "65981131880",
      "member_cpf": "02312568845",
      "member_email": "leaeid@terra.com.br",
      "member_id": "oQTbeRU7vUB5Qi76EgU6",
      "member_name": "Paulo Ruiz Lúcio de Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.61
    }
  }, {
    "id": "GgGBcvoXmdbnIwdSZp7X",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-03-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81999716404",
      "member_cpf": "42802709453",
      "member_email": "f.moraes1@uol.com.br",
      "member_id": "FjybEQe6bu0giHrR1tNN",
      "member_name": "Fernando Ribeiro Moraes Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "GgWpboWnJeiGZBgpVYvT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999707350",
      "member_cpf": "06276555053",
      "member_email": "servicor@terra.com.br",
      "member_id": "VbemlUiQZS2XiFQdu4NW",
      "member_name": "Fernando Antonio Lucchese",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Gk4F5dtnPpctEdbIgdqj",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61981739790",
      "member_cpf": "41855892120",
      "member_email": "dr.flavioabreu@gmail.com",
      "member_id": "19VxaP6qanQSGRdxoPlU",
      "member_name": "Flávio Dias de Abreu",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "GpBJAX754xhvp9XOHhPQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "55999747960",
      "member_cpf": "15890759272",
      "member_email": "heidypc@sbccv.org.br",
      "member_id": "lB4dneoxhoy1Dthzc615",
      "member_name": "Heidy Piccolotto Carvalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "Gu4iB7xniA5AaGdfG3kt",
    "data": {
      "Tid": "710861",
      "authorizationCode": "710861",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2007-04-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999675839",
      "member_cpf": "53843096015",
      "member_email": "rogerabr62@gmail.com",
      "member_id": "1Yt2q59uHYGbH4Gszx9m",
      "member_name": "Rogério de Souza Abrahão",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "710861",
      "payment_date": "2007-04-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "H8Adp6ybqNwZVSIgMYTt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "12997186418",
      "member_cpf": "04442049890",
      "member_email": "genivaldocoelhodesouza@gmail.com",
      "member_id": "Bdnr5I8W0GbI5EH0wobK",
      "member_name": "Genivaldo Coelho de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 467.9,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 467.9
    }
  }, {
    "id": "HAzHNadjPqidmGcWgApH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-03-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999895064",
      "member_cpf": "02031783866",
      "member_email": "clinicah.falcao@hotmail.com",
      "member_id": "HFs5uIlt7Iwhi7wnz5PC",
      "member_name": "Hélio Carlos Brandão Falcão",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "HDrUvDFHyQdXKnQhRgXX",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999754657",
      "member_cpf": "01600796672",
      "member_email": "geraldo3554@gmail.com",
      "member_id": "IXaLMfW1utCmibm5168n",
      "member_name": "Geraldo Paulino Santana Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "HEAYgENdsZFCOzzXSy4n",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "32999875363",
      "member_cpf": "11743646615",
      "member_email": "aamiana@uol.com.br",
      "member_id": "7U9uYv5rAnP2HVwZPRie",
      "member_name": "Antonio Augusto Miana",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "HHc4h0bLAn2ioIfLRSCn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "5399821012",
      "member_cpf": "05010632004",
      "member_email": "roso.sul@gmail.com",
      "member_id": "5M9ukKwIu1n86GD0NpeZ",
      "member_name": "Joao Alberto Roso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "HJrkMcnxOXJ9ugGBBCVp",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999512669",
      "member_cpf": "11897880634",
      "member_email": "bayardgontijo@gmail.com",
      "member_id": "3jXuDGouXH3dLJa5gWx1",
      "member_name": "Bayard Gontijo Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 369.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 369.61
    }
  }, {
    "id": "HRevV2RMCaZoRPqBuxpd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999848699",
      "member_cpf": "76169880678",
      "member_email": "scaporali@uol.com.br",
      "member_id": "N0o4B4PhcsYX8zMoLbFR",
      "member_name": "Sérgio Caporali de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "Hj7RjUTI1ZwdZHxtBxAx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "87297370878",
      "member_email": "",
      "member_id": "Y309HqP05w2HIfHOSNhQ",
      "member_name": "Luiz Eduardo Villaca Leao",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Hl9qZAOi59wGFJYEw1A0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "63999341982",
      "member_cpf": "90756258804",
      "member_email": "cardiologiahf@hotmail.com",
      "member_id": "A7ft6pdcFNAODAE8lcEs",
      "member_name": "Henrique Barsanulfo Furtado",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "HlPWZc4fzEYh1zmA95pG",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2006-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11986898920",
      "member_cpf": "00343512807",
      "member_email": "miguelmaluf@gmail.com",
      "member_id": "oig6OVPDHyCjQHedFYGa",
      "member_name": "Miguel Angel Maluf",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "Hvs5oRMHlUHW6h4o4IaN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19996018535",
      "member_cpf": "10274174855",
      "member_email": "gcar@hotmail.com",
      "member_id": "fw6hFmYYPOCIXsxdSLRm",
      "member_name": "Gustavo Calado de Aguiar Ribeiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "I0wqy2U8Kg3uwujJDRfa",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999195443",
      "member_cpf": "31105874753",
      "member_email": "leoncio.feitosa@globo.com",
      "member_id": "KTpY0uzM6T7ZTAMgwz2t",
      "member_name": "José Leôncio de Andrade Feitosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "I7C975WrbDJ8SGoJKlAH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19997816859",
      "member_cpf": "00033127808",
      "member_email": "amauri.groppo@terra.com.br",
      "member_id": "Xywh7J89TS2CTgS4KLz7",
      "member_name": "Antonio Amauri Groppo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "IFlr7hgmythk0sQlIcIo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-04-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51981474796",
      "member_cpf": "19899246034",
      "member_email": "tofani.ez@terra.com.br",
      "member_id": "ageruc1pzVnXgL0BOYtZ",
      "member_name": "João Ricardo Michielin Sant'anna",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "II9rXOmpaH3mzWPdCDRD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "H2AoWhktluQaWYuPydHC",
      "category_name": "Não Sócio",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996552285",
      "member_cpf": "14661773810",
      "member_email": "ricardo.dias@incor.usp.br",
      "member_id": "9k0EGRTP67Xcz878MBZa",
      "member_name": "Ricardo Ribeiro Dias",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "IISxEKsJR52rmdwUARLn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "43999918657",
      "member_cpf": "37279009891",
      "member_email": "circardiaca@sercomtel.com.br",
      "member_id": "EpTBpjMogpZ2tXmHRyVt",
      "member_name": "Francisco Gregori Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "IQdD1MNwgEO4lKcZaNQS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999826172",
      "member_cpf": "76301273753",
      "member_email": "melchior.lima@me.com",
      "member_id": "CAXRyYBoEGo7TzzuYL31",
      "member_name": "Melchior Luiz Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "IXySVGsZdwN28lLi2D0q",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999774745",
      "member_cpf": "00030660610",
      "member_email": "ccv@santacasabh.org.br",
      "member_id": "t6u6y39k5XtGmS4hEN7w",
      "member_name": "Juscelino Teixeira Barbosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "IglMtMWQHVWVeIpaoNnp",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81991459345",
      "member_cpf": "08416044449",
      "member_email": "ricardo.lima@upe.br",
      "member_id": "GkPljbxZKTpR5XQl9nze",
      "member_name": "Ricardo de Carvalho Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "ItycRn3u7ghXDDXePtNL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-04-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999759927",
      "member_cpf": "43837000125",
      "member_email": "bruno.pinheiro@sbccv.org.br",
      "member_id": "jTqlQiYMsaalx9BVnMCU",
      "member_name": "Bruno Botelho Pinheiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.61
    }
  }, {
    "id": "JAJrDacqwi0GIRvBFCAm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "18528066800",
      "member_email": "dantonloures@onda.com.br",
      "member_id": "eJBXnZx9OrtCIvBow7m9",
      "member_name": "Danton Richlin da R. Loures",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "JDP0LpB69cj4mulrWW9u",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6299716260",
      "member_cpf": "63573954715",
      "member_email": "jbmartinsm@yahoo.com.br",
      "member_id": "iJ3WO0rB6Zhn6RFehQPX",
      "member_name": "Joao Batista Martins de Moraes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.61
    }
  }, {
    "id": "JMd8xVOXq2ZleuK91cjv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2007-04-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "92991120070",
      "member_cpf": "53043081153",
      "member_email": "fausto-pina@hotmail.com",
      "member_id": "b6SSyZwUk44dZEkLOnhs",
      "member_name": "Fausto de Pina",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "JNZiJTtwCkHvsr3RqJ3x",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-02-13T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11994521412",
      "member_cpf": "04907433824",
      "member_email": "vaidergorn@terra.com.br",
      "member_id": "IKnbJoGajyBox5tisbul",
      "member_name": "Jairo Vaidergorn",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-13T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "JPFoFP1CYakujRJzcoFn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11981030900",
      "member_cpf": "08572407812",
      "member_email": "mgsilas@uol.com.br",
      "member_id": "6QsZ7XtCnoSFqJC9AiQk",
      "member_name": "Marcelo Grandini Silas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "JXGbwRFXdcazR5ih4grJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-05-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21993482293",
      "member_cpf": "09740333400",
      "member_email": "jefferson_chaves@uol.com.br",
      "member_id": "7DQlmrUktMDB7A2msJO4",
      "member_name": "Jefferson Cavalcanti Chaves",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-05-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "JaljPxSw1NbwZdrmoLVZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27981847777",
      "member_cpf": "08585248807",
      "member_email": "rbdauar@hotmail.com",
      "member_id": "esB6KSaVUwhgsmI2VwGu",
      "member_name": "Renato Bauab Dauar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "JfyzwSyrTswRN02qW4pd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67992055125",
      "member_cpf": "50091239168",
      "member_email": "afs@terra.com.br",
      "member_id": "p2WXU6vl6kYkkD3hs2aJ",
      "member_name": "Arino Faria da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 274.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 274.94
    }
  }, {
    "id": "Jionu46qKccuDmF5PHP0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00140287272",
      "member_email": "dreis@unises.com.br",
      "member_id": "7rW0fVOfbKfNbNmq9RZd",
      "member_name": "Daniel Jose Dos Reis",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "JmkY42e8S0jaUYqtSzAw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67982026162",
      "member_cpf": "01874685754",
      "member_email": "marcoantonioaraujodemello@gmail.com",
      "member_id": "SWOUm8l1mgfj2QsBIXLu",
      "member_name": "Marco Antônio Araújo de Mello",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "K8PBjxTkf2ky1EuK6ptM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999813124",
      "member_cpf": "37964127772",
      "member_email": "mnader.vix@gmail.com",
      "member_id": "pibzD7azHzwiiIfXDXHW",
      "member_name": "Moysés Pedro Amoury Nader",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 360.01,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 360.01
    }
  }, {
    "id": "KB4pp5zFDrjcn566zWtH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "54981116464",
      "member_cpf": "18916384087",
      "member_email": "paulo_azambuja@mac.com",
      "member_id": "kL5APSHZ6u6APGYa95o1",
      "member_name": "Paulo Ceratti de Azambuja",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "KGqpx05Li4CkNdiaUtQM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14981125834",
      "member_cpf": "07039039850",
      "member_email": "acbrau@terra.com.br",
      "member_id": "FjBvk4ouP3zo7Gkj3xsc",
      "member_name": "Antonio Carlos Bráulio de Camargo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "KMEtpHtLOOyhCSQb6Owz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14997371770",
      "member_cpf": "01873137842",
      "member_email": "fakellysilva@hotmail.com",
      "member_id": "DIpYIpLu4uQgOjU0pqpj",
      "member_name": "Antonio Estéfano Germano",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "KPQArnhAab0AgG86rLFH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "92991161494",
      "member_cpf": "35974303172",
      "member_email": "sf.avelar@terra.com.br",
      "member_id": "Gu42e7rrf5hQ8eUdN6L0",
      "member_name": "Silas Fernandes Avelar Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 417.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 417.61
    }
  }, {
    "id": "Ka69RQ47VWDvTzPFE2B6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996227192",
      "member_cpf": "15113623830",
      "member_email": "ctanama@hotmail.com",
      "member_id": "pwRGgdGInnHNtmVajJLN",
      "member_name": "Carla Tanamati",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 621.8700000000001,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 621.8700000000001
    }
  }, {
    "id": "Kcx3KnjFqIWgaWzTDi7v",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21988883235",
      "member_cpf": "00139386387",
      "member_email": "gmramalho@globo.com",
      "member_id": "5bhxkpzPbNUlliwHcoML",
      "member_name": "Geraldo Martins Ramalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "KmXtEXu2lBsbLTV8HEEI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "84999748787",
      "member_cpf": "15540880463",
      "member_email": "marcosaflima@cardiol.br",
      "member_id": "G2yaTkqhk7erdbR3URcK",
      "member_name": "Marcos Antonio Ferreira Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "KpKNJbW4lFjCJ8sMBg0H",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81999734718",
      "member_cpf": "26458241453",
      "member_email": "tenorioeuclides@gmail.com",
      "member_id": "apKnHl2hxD1NfY419lv1",
      "member_name": "Euclides Martins Tenorio",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "KsU9pgNSVfkbgomvfkqO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21981160246",
      "member_cpf": "33196354849",
      "member_email": "paulosamuelsantosf@gmail.com",
      "member_id": "3hNTcNdhrpyBL6Yedn5p",
      "member_name": "Paulo Samuel Santos Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "KuVgOjeKKCuuw0YcsAWO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-05-04T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "18997732600",
      "member_cpf": "02298484864",
      "member_email": "l.h.cavalcanti@hotmail.com",
      "member_id": "6233lHUEGFt0g3Uvzxyc",
      "member_name": "Lysandro José de Hollanda Cavalcanti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-04T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "KznPRGA523Ru5768LDpl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17991542024",
      "member_cpf": "50514148853",
      "member_email": "hapgama@terra.com.br",
      "member_id": "QcUI4qDGIbgSt2cHRqcG",
      "member_name": "Hélio Augusto Pascoal da Gama",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "L5Gw5dTvHQnir0LUcp1h",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999846090",
      "member_cpf": "05620996620",
      "member_email": "claudioasalles@yahoo.com.br",
      "member_id": "BW6KJvr7zKPyLnkAZKx2",
      "member_name": "Cláudio Azevedo Salles",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "L8KkKaTmJoOtmJxeJWJm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31984667157",
      "member_cpf": "19584113615",
      "member_email": "roneypeixoto@gmail.com",
      "member_id": "AVkDCdr1rxV5Pj5Edxyj",
      "member_name": "Roney Ronald Peixoto da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "LPce8ri2uWhsY6rPuo4y",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1182857373",
      "member_cpf": "10312416806",
      "member_email": "ronaldohonorato@terra.com.br",
      "member_id": "2P5sB0hUpZwpUaAScd6H",
      "member_name": "Ronaldo Honorato Barros Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 320.01,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 320.01
    }
  }, {
    "id": "LZJXlzsqhdMmhpdi5WOV",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-01-17T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "01019813768",
      "member_email": "javieira@cardiol.br",
      "member_id": "iXcvJ3gii6aZuSjdRNY1",
      "member_name": "Jose Aldrovando de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-01-17T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "LbnGobNRCLcsyP2dYAHq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "13997275111",
      "member_cpf": "18773964867",
      "member_email": "luciano.carneiro@superig.com.br",
      "member_id": "4UctxeQNOLJtltNyWTTa",
      "member_name": "Luciano Jannuzzi Carneiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "LbrxCPLESTqBdDsriDq3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-04-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(34) 99855-9045",
      "member_cpf": "00079296688",
      "member_email": "fabianofvieira@gmail.com",
      "member_id": "9oMnb5M1SmJGM7fVNeet",
      "member_name": "Fabiano Ferreira Vieira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-04-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "Lc8TW161EeYDtrkSgpCr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999767299",
      "member_cpf": "07477180678",
      "member_email": "januariomdesouza@uol.com.br",
      "member_id": "cXRu9AsNDHY6A97YpTDs",
      "member_name": "Januário Manuel de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "LdspEVMk4ojSDBH3FsBC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999861076",
      "member_cpf": "71592563791",
      "member_email": "fernando.binello@gmail.com",
      "member_id": "g4QSh50a65sTwlsWQtCe",
      "member_name": "Fernando César Lopes Binello",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "LhMsSwTBLFigyKj45ip6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11994445829",
      "member_cpf": "08952852826",
      "member_email": "lalisboa@uol.com.br",
      "member_id": "UFGdWWcOzmh6GDgD0dDC",
      "member_name": "Luiz Augusto Ferreira Lisboa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "LqmrYGiLXRt8uzXPQ9Gs",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "45988180047",
      "member_cpf": "65873491968",
      "member_email": "jkmadeira@gmail.com",
      "member_id": "UtvN2wCNEVCIr4ZpNDw8",
      "member_name": "João Madeira Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "M4fc1utCmThV0UBgQzRD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-03-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16991313171",
      "member_cpf": "55019234834",
      "member_email": "prbevora@gmail.com",
      "member_id": "HpAQ9NQjmjwtFQlGbFXQ",
      "member_name": "Paulo Roberto Barbosa Evora",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 445.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 445.61
    }
  }, {
    "id": "M7dCGI9Z77dtcFSCyZXa",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-04-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17997720210",
      "member_cpf": "07039488817",
      "member_email": "avancile@uol.com.br",
      "member_id": "NFJKzIZsYtnQEy06Kpey",
      "member_name": "Luís Ernesto Avanci",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "M8BPTTe0GwnUyceFmY2f",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-03-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "92984342405",
      "member_cpf": "44673574834",
      "member_email": "mterrazas2009@icloud.com",
      "member_id": "eR4ToFvhce2njk6JQqTq",
      "member_name": "Mariano Brasil Terrazas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "MBAfUppNC3TnSNNuIXPP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(11) 3832-3148 ",
      "member_cpf": "04179752875",
      "member_email": "jagmenegoli@terra.com.br",
      "member_id": "2z89WB07kcbs3MC8KdDT",
      "member_name": "José Antonio Garcia Menegoli",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.6
    }
  }, {
    "id": "MK0KTR2sqvsXnniYi7AM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "43991019842",
      "member_cpf": "16017884875",
      "member_email": "alexmurakami@uol.com.br",
      "member_id": "5iuEbKBK6LwbyajBciiS",
      "member_name": "Alexandre Noboru Murakami",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "MQVAv314MIPD4P5M8zYT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999924304",
      "member_cpf": "47890894015",
      "member_email": "lalbuquerque.cabral@gmail.com",
      "member_id": "ZnzxDdrZVoNZPLuaxGTG",
      "member_name": "Luciano Cabral Albuquerque",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "MRAsjuu0XtoLbM1BmoTv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999969550",
      "member_cpf": "54535212520",
      "member_email": "adriano.rita@uol.com.br",
      "member_id": "tBHeagNUZwgB1pYoCNqp",
      "member_name": "Adriano Lima Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "MSKx4Q7T4Yd8KgGi3BmE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-06-24T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22997437050",
      "member_cpf": "84809086704",
      "member_email": "celmecaetano66@gmail.com",
      "member_id": "bFt6A2pt7qpEnBdM86LG",
      "member_name": "Celme da Silva Caetano Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-06-24T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "MYLC41yeAxgEzTVY57VG",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-04-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999895963",
      "member_cpf": "38735407468",
      "member_email": "incorcrianca@yahoo.com.br",
      "member_id": "uk3OMbPvTpFbkwnLy5bI",
      "member_name": "Valdester Cavalcante Pinto Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Mh8KtG3grB1dw7oIjuNK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6199678500",
      "member_cpf": "00018236120",
      "member_email": "cardiocentro@ambr.org.br",
      "member_id": "vAhYItAmOZK6L4Uif8EY",
      "member_name": "Andre Esteves Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 399.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 399.99
    }
  }, {
    "id": "Mlnn4T52e227rjhJmHRA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41988743044",
      "member_cpf": "40144526972",
      "member_email": "ysuzuki3355@gmail.com",
      "member_id": "AUKtkrpT2pxnV9VtlQiR",
      "member_name": "Yukio Suzuki",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 405.19,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 405.19
    }
  }, {
    "id": "MrPKnlWYjDpsZ8KfpqFD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-01T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16981268412",
      "member_cpf": "07439504887",
      "member_email": "joaojcarneiro@hotmail.com",
      "member_id": "lDf0oOEvDzw9nOILataj",
      "member_name": "João José Carneiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-01T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "Mybx3Fdud7hmUkPUqwzk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "4199678787",
      "member_cpf": "05422328809",
      "member_email": "jlverde@onda.com.br",
      "member_id": "YJRpH5buTclFbZJjCOHk",
      "member_name": "Jose Luiz Verde Dos Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "N1Us3Qq9RlFPwQjzO7ai",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999812977",
      "member_cpf": "20633610020",
      "member_email": "wagnermichaelpereira@gmail.com",
      "member_id": "Cgsi8Ebo9IxzUgYCiCsC",
      "member_name": "Wagner Michael Pereira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "N1l48izaLBIAGpXIVP5C",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996032944",
      "member_cpf": "86026895868",
      "member_email": "piccardivl@hotmail.com",
      "member_id": "iVAz9FUVWZXfTDGrl6FE",
      "member_name": "Vera Lúcia A. Molari Piccardi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "N2nF23DAa3D7XgblqhDS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-04-21T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19992049575",
      "member_cpf": "30606500200",
      "member_email": "fxbarrosneto@gmail.com",
      "member_id": "KUtUXl8ZxjMh1gZhU5pI",
      "member_name": "Francisco Xavier do Rego Barros Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-21T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "N3ZDq9w8oZz16WWPW5ea",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "4499111377",
      "member_cpf": "70288860934",
      "member_email": "",
      "member_id": "0p748oebpNQ4mOXwJu1V",
      "member_name": "Leila Satomi Fucuda",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "N5dnuaOWVCckZf7tvvBS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21971274301",
      "member_cpf": "03014576204",
      "member_email": "m.nunes@hotmail.com",
      "member_id": "xwv0eXrASx8uAKCrsDLh",
      "member_name": "Edson Magalhães Nunes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "NW7d0QgavewDrIhFHY6D",
    "data": {
      "Tid": "10041894",
      "authorizationCode": "10041894",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61981022213",
      "member_cpf": "21278178856",
      "member_email": "freddyponcemd@hotmail.com",
      "member_id": "MJBlzxDSoWnWQIg4PLHe",
      "member_name": "Freddy Hernan Ponce Tirado",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "10041894",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "NWAVoD2a3EOYEVBEqskV",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81988339099",
      "member_cpf": "58265341415",
      "member_email": "alexmottamenezes@gmail.com",
      "member_id": "k8EDtYq885S7t0TnIAme",
      "member_name": "Alexandre Motta Menezes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 401.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 401.94
    }
  }, {
    "id": "NXKa0ZaLhwvBbAEgiq2j",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-04-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31992041455",
      "member_cpf": "27647005634",
      "member_email": "adalbertofsobrinho@hotmail.com",
      "member_id": "B5UC9zEGXkJiT2syTNHq",
      "member_name": "Adalberto Freire Sobrinho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 443.3,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 443.3
    }
  }, {
    "id": "NXUj364rirrwGLep4usx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "5499811244",
      "member_cpf": "25540440072",
      "member_email": "mfalleiro@annex.com.br",
      "member_id": "47iHPww8sKcby5OXZthk",
      "member_name": "Roque Paulo Torres Falleiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "NaS8vuxLavhmT5XDZpxR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-07-29T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996324883",
      "member_cpf": "09090831851",
      "member_email": "marcapassolpmedicos@yahoo.com.br",
      "member_id": "QF76Wi7kXBKUOUKgYUl1",
      "member_name": "Wilson Lopes Pereira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-07-29T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "Ni7JJUeIAbQmh6TQPIRO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999834827",
      "member_cpf": "24952362604",
      "member_email": "dielson.bhz@terra.com.br",
      "member_id": "XfLmXrmOyzy0xnIyeXh5",
      "member_name": "Dielson Teixeira Sampaio",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "NpIA8cd6GYdHwBo0Xc6S",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21981345270",
      "member_cpf": "43690580668",
      "member_email": "jdfmagalhaes@gmail.com",
      "member_id": "W6R1sp2nVC2bu0aKoSMN",
      "member_name": "Jefferson Duarte Flávio Magalhães",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "NyiQKi36mqGj7DZiPrxw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "13981247572",
      "member_cpf": "10277073863",
      "member_email": "fernandoplatania@uol.com.br",
      "member_id": "CscxREQE3Pd18o3oqnaG",
      "member_name": "Fernando Platania",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "O95rXsE9C6rdW84P7I13",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "63981119313",
      "member_cpf": "17610372854",
      "member_email": "jftcaceres@uol.com.br",
      "member_id": "qsXRu9LcIyVtZe1wdckz",
      "member_name": "Juan Fernando Terrones Cáceres",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "OB6w2r2zfXiwdzdKapKJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2199814469",
      "member_cpf": "51067440744",
      "member_email": "",
      "member_id": "vMep0xEPI3l3ryDSW5DN",
      "member_name": "Sergio Luiz Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 462.69000000000005,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 462.69000000000005
    }
  }, {
    "id": "OIAZ6umPMoDqXG6Qqo9c",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "91487137834",
      "member_email": "",
      "member_id": "QkzesV40TnGKk4UzuhZ4",
      "member_name": "Wagner Tadeu Ligabo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 310.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 310.93
    }
  }, {
    "id": "OLY22xWtgQlfG5PCu48r",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "H2AoWhktluQaWYuPydHC",
      "category_name": "Não Sócio",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11998555054",
      "member_cpf": "14300651841",
      "member_email": "eduardocoelhodesouza@uol.com.br",
      "member_id": "fvZaWZAk1FJRljDCXCej",
      "member_name": "Eduardo Coelho de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "OMGCTthE7ONS1lCAZn4E",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83988631460",
      "member_cpf": "14354268434",
      "member_email": "barbosa.alex@uol.com.br",
      "member_id": "gPIzjIUNwp6J6ygFuE6G",
      "member_name": "Alex Barbosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "OOGkhvNrwdaB4LnU1SS6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999772208",
      "member_cpf": "76477010615",
      "member_email": "luizcmlima@gmail.com",
      "member_id": "urqa8kheZfSyrtQUcRh6",
      "member_name": "Luiz Cláudio Moreira Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "OOtsMuuaJ635IeqQeIDr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67981268456",
      "member_cpf": "44521464149",
      "member_email": "claudiocirurgiaocardiaco@gmail.com",
      "member_id": "CrMEJlBzYlh1i1mwik9W",
      "member_name": "Cláudio Albernaz César",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 288.28000000000003,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 288.28000000000003
    }
  }, {
    "id": "OozUGJFzD9mzw8bnE2Wy",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-01-18T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27998504678",
      "member_cpf": "02450716793",
      "member_email": "fabriciootavio@hotmail.com",
      "member_id": "OFPTWnVjukCS3WBKx03I",
      "member_name": "Fabrício Otávio Gaburro Teixeira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-01-18T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "OwWG2qen68xY6nK27xYe",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "SMkHCbzIvfJeO4ddgj6h",
      "category_name": "*Cassados",
      "date": "2004-04-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(81) 9971-8455",
      "member_cpf": "19353871468",
      "member_email": "ClaudioAmaroGomes@tiuas.com",
      "member_id": "2qUkWr7yMsRajk3OroCw",
      "member_name": "Claudio Amaro Gomes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 106.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 106.67
    }
  }, {
    "id": "OznYcYjyyJWZcUCLG1gg",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-05-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "05330941865",
      "member_email": "",
      "member_id": "EyTaAP9CF73vciyYul1q",
      "member_name": "Emidgio Ruben Araujo Ramirez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-05-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 300,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 300
    }
  }, {
    "id": "PCHTZXAOpofCkViAq7Sp",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999726521",
      "member_cpf": "13687271153",
      "member_email": "luizbrasil@sbccv.org.br",
      "member_id": "Gjk0ZDxlhsVB3367YJYB",
      "member_name": "Luiz Antonio Brasil",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "PFiRV5u4a6DdGWHqHWci",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11983545509",
      "member_cpf": "20593589815",
      "member_email": "laurotkawabe@gmail.com",
      "member_id": "woB9gc4AkEy6AreFfAmb",
      "member_name": "Lauro Takumi Kawabe",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "PKHHIGmip5rX6Fr5cykT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-11-28T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "78999779516",
      "member_cpf": "00159068843",
      "member_email": "jabaucia@hotmail.com",
      "member_id": "IlRWq11fbN0LUA1fi0In",
      "member_name": "José Augusto Baucia",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-11-28T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "PMesufK1oaAgJsWX9LMv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-11-17T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "20088221768",
      "member_email": "",
      "member_id": "NrWmMHnUjfT73dSy9p7N",
      "member_name": "Antonio de Biasi Wyszomirski",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-17T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "PNb9E3MzqghZi9td28e7",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991923600",
      "member_cpf": "00777550814",
      "member_email": "ana.mrp@uol.com.br",
      "member_id": "eLHjvjnNT7rXm3fCSSUa",
      "member_name": "Ana Maria Rocha Pinto E Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "POAFTGnZZxGF02hct9ey",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "98999911107",
      "member_cpf": "10477150829",
      "member_email": "marcoassef@terra.com.br",
      "member_id": "Q9ArhqnmGaVDOKUF8y1g",
      "member_name": "Marco Aurélio Salles Assef",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "PhypLJKoxG8KLZbteZTP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "02019870827",
      "member_email": "hkhasimoto@uol.com.br",
      "member_id": "ZU6gKyglHRMVZdR46pSm",
      "member_name": "Helio Kiyoshi Hasimoto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "Pl6fXq4GQEWczzQ17pMr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22999825510",
      "member_cpf": "42430992787",
      "member_email": "claudio.sobrosa@gmail.com",
      "member_id": "UIipvGmaHTV2egvFTDBY",
      "member_name": "Cláudio Guedes Sobrosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "QAkAwFre1KlUiuB0scGY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41991999495",
      "member_cpf": "10961915803",
      "member_email": "celsonascimento@globo.com",
      "member_id": "y42ODmUI5yLff7hicN0d",
      "member_name": "Celso Soares Nascimento",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "QD9lrKGLbJJrDROudONq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21993454950",
      "member_cpf": "47869852791",
      "member_email": "hermesfelippe@globo.com",
      "member_id": "juQHId192qssIkMj2vrL",
      "member_name": "Hermes de Souza Felippe",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "QGnWry2A2qgYHoemNrYO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1199009254",
      "member_cpf": "44626229868",
      "member_email": "drandrad@terra.com.br",
      "member_id": "RGAVcNHsiJSSEi1ssk5y",
      "member_name": "Jose Carlos Silva de Andrade",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "QN1UJXryMd5vdlwLInRK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47984452447",
      "member_cpf": "44642547991",
      "member_email": "faustino@fjrcardiologia.com.br",
      "member_id": "Ow58SuW8ZVUrZD9UbmD5",
      "member_name": "Faustino José Rebellato",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "QPsItjG2LtmCP9yo4194",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11992920085",
      "member_cpf": "05051308821",
      "member_email": "drmarioissa@yahoo.com.br",
      "member_id": "7ssWCdr7OaxnKxcgKRcf",
      "member_name": "Mário Issa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "QRHARFeTqDpwyj6VUIpA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "13997132529",
      "member_cpf": "73102792804",
      "member_email": "caconforti@gmail.com",
      "member_id": "9xrvsQWGSGdOJNw7vDJH",
      "member_name": "César Augusto Conforti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.6
    }
  }, {
    "id": "Qz91dbYZhUrJ0XqD3PvL",
    "data": {
      "Tid": "1798",
      "authorizationCode": "1798",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-11-30T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "01079387820",
      "member_email": "",
      "member_id": "dUAqUOEkZeyHQYZCI4L3",
      "member_name": "Rubens de Guimaraes Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "1798",
      "payment_date": "2004-11-30T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 86.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 86.68
    }
  }, {
    "id": "RDY82Y2UxRRIwFnTg1JY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-04-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41984416000",
      "member_cpf": "81777922968",
      "member_email": "viniciusw@hotmail.com",
      "member_id": "n2juAqlE737r3seFtUkI",
      "member_name": "Vinicius Nicolau Woitowicz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-04-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "RGx6X749LN0geadWZzzV",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22997720777",
      "member_cpf": "72062290772",
      "member_email": "cbarrozo@gmail.com",
      "member_id": "Ih1ooG2fpx652l6oU9lm",
      "member_name": "Carlos Alberto Mussel Barrozo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "RLmKnF28uOrj4yWtFl5n",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999827347",
      "member_cpf": "26093898091",
      "member_email": "juarezrode@terra.com.br",
      "member_id": "pEaGaUzdznqNjGWwWjr6",
      "member_name": "Juarez Rode",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "RRcazHcJnLqvdklqVPvm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "02469238811",
      "member_email": "",
      "member_id": "4okf3w6AGJC3biJvrpIE",
      "member_name": "Wilson Ferreira Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "RblTrhowFfRZkqwRQlPK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999674365",
      "member_cpf": "92214940987",
      "member_email": "gkpimentel@gmail.com",
      "member_id": "QZjFuLMJXZlRdcYRyw2I",
      "member_name": "Gustavo Klug Pimentel",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "RdBuPS1pCK0iUaR0tHAw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "55349173020",
      "member_cpf": "55852157368",
      "member_email": "raelson@cardiol.br",
      "member_id": "GbeVPCf9h5e1vHpfv8RO",
      "member_name": "Raelson de Lima Batista",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "RoUUPpf6mBocRKHKMQ2g",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996393005",
      "member_cpf": "00508985820",
      "member_email": "enio.buffolo@terra.com.br",
      "member_id": "KUrfspRDNH3y1f5UxEXv",
      "member_name": "Enio Buffolo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "RoZyjmEWS5prYRaoqB2c",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999901932",
      "member_cpf": "08521707851",
      "member_email": "hueb@uol.com.br",
      "member_id": "xOE7su8C93MoAlR0hIgK",
      "member_name": "Alexandre Ciappina Hueb",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "RpK5TppOlh2eNL0vn57M",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999825379",
      "member_cpf": "34002006034",
      "member_email": "esaadi@terra.com.br",
      "member_id": "vklFqYm25ki5o1mzphiQ",
      "member_name": "Eduardo Keller Saadi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "RrGlecYAtdgJD7jSX05f",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-03-21T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41991275000",
      "member_cpf": "07232896972",
      "member_email": "robertodecarvalho44@gmail.com",
      "member_id": "87zqmcFtJ9GNHX8PujS0",
      "member_name": "Roberto Gomes de Carvalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-21T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "RsCuYBWPGDVfgdWTxKmt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11971211945",
      "member_cpf": "08993260800",
      "member_email": "timerocha1@gmail.com",
      "member_id": "xngyH6nZf72lc2tWOPDs",
      "member_name": "Roberto Rocha E Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "S4hyOtMm3BmC49tbHRvA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-05-13T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "4191196855",
      "member_cpf": "62863479920",
      "member_email": "lrmacedolopes@terra.com.br",
      "member_id": "VtkFUkoMokXSH4oyYXlV",
      "member_name": "Luiz Roberto Macedo Lopes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-05-13T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425.01,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425.01
    }
  }, {
    "id": "S5dAIA5SGVgcEmsqEnkb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2007-02-08T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6581161313",
      "member_cpf": "25846779549",
      "member_email": "eduardo.as@uol.com.br",
      "member_id": "dl9ExYOldg3gF71dr95k",
      "member_name": "Eduardo Almeida Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-02-08T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 300,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 300
    }
  }, {
    "id": "S5sc8aOG6xLipTPEFvUf",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11981810768",
      "member_cpf": "89722604872",
      "member_email": "alfredo.i.fiorelli@gmail.com",
      "member_id": "SV8aQrmdso9sBTBL6zU0",
      "member_name": "Alfredo Inácio Fiorelli",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "S682iu8rzFo1DPyWejnv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11941411530",
      "member_cpf": "16573205880",
      "member_email": "doutorlima@doutorlima.com.br",
      "member_id": "p8G3hbnVktL1Svv8UzdO",
      "member_name": "José de Lima Oliveira Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "SD74NZh9yvBPflwBZIYC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "40741058221",
      "member_cpf": "00027656837",
      "member_email": "a.riso@uke.de",
      "member_id": "xn3pVxhOMDkawPGKxrG8",
      "member_name": "Arlindo Almeida Riso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "SfkkOBVogneCVwMLW8iM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6292413472",
      "member_cpf": "32293003191",
      "member_email": "",
      "member_id": "a5RVRaIXqKTapy3JvEri",
      "member_name": "Gilson Jose Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.61
    }
  }, {
    "id": "SnRphV8bvaF6q7SUDJIC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-01-15T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999825538",
      "member_cpf": "21698961634",
      "member_email": "rodolfo.vigil@hotmail.com",
      "member_id": "NTVn2838RvhOXSqQ7agS",
      "member_name": "Rodolfo Guillermo Vigil Verastégui",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-01-15T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "T9EQ5wTPkzClZI64iixm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2005-02-09T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "24283061891",
      "member_email": "randrade@fmb.unesp.br",
      "member_id": "oTPR16XfMn8D8d5jKdWO",
      "member_name": "Rubens Ramos de Andrade",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-02-09T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "TGSIlmuTNe8OZth1cK30",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47988376663",
      "member_cpf": "07409902841",
      "member_email": "cezarnery2010@hotmail.com",
      "member_id": "icZZ8KzIsl5wVfwZjIQX",
      "member_name": "Cezar Nery Iervolino Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.93
    }
  }, {
    "id": "TJVmzJwiCkoZhB9nwkro",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62993801820",
      "member_cpf": "53408578168",
      "member_email": "rafahaddad@hotmail.com",
      "member_id": "ZNlFpcMeMejJYDJbWUfZ",
      "member_name": "Rafael Haddad",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 274.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 274.94
    }
  }, {
    "id": "TL5ZTViVNMRDftV89KlE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "79999780466",
      "member_cpf": "11633220591",
      "member_email": "rikakakuda@hotmail.com",
      "member_id": "HGZkozWwRpK3iFbgNLdH",
      "member_name": "Rika Kakuda Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "TNSFitQToowC4DPopQX7",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "43999948986",
      "member_cpf": "91777844991",
      "member_email": "arnaldo.okino@uol.com.br",
      "member_id": "l4rDJlQU0bo35wLxJrv0",
      "member_name": "Arnaldo Akio Okino",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "TNVDNsNg1WYu0VhYtkbh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83999839986",
      "member_cpf": "05948924491",
      "member_email": "josereinaldomc@yahoo.com.br",
      "member_id": "la75wT9Th9iFvmmjrRMP",
      "member_name": "José Reinaldo de Moura Coelho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "TQyeMOrFEC523emjUJgT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991949533",
      "member_cpf": "39121046468",
      "member_email": "wanewmanlins@gmail.com",
      "member_id": "ipYdVH4QVNIWxHikji4D",
      "member_name": "Wanewman Lins Guedes de Andrade",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "TRTpUdLKH61Wlb0XxbeE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2191436850",
      "member_cpf": "45513015749",
      "member_email": "filgueiras@cardiol.br",
      "member_id": "n1DD7oQiZuTBNbRDSj42",
      "member_name": "Carlos Luiz Filgueiras",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "TTTCI1Yxd2HoV0ts0vYP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-04-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982253074",
      "member_cpf": "03201956364",
      "member_email": "hmacruz@outlook.com",
      "member_id": "1RidaYqaeBeASEcmo4c3",
      "member_name": "Hugo de Moraes Sarmento Macruz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "TZlQwfCdpbyt3njSk8qA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-02-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31991666339",
      "member_cpf": "55143920663",
      "member_email": "eduavrocha@gmail.com",
      "member_id": "HbH1jwatZQm6ly3bOqFo",
      "member_name": "Eduardo Augusto Victor Rocha",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 482.8,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 482.8
    }
  }, {
    "id": "TgO7DNgyqzAYXQRkkSa2",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-09-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999893727",
      "member_cpf": "26081261700",
      "member_email": "rubensgiambronifilho@gmail.com",
      "member_id": "S9zmUmwliYvoh8vL0eTa",
      "member_name": "Rubens Giambroni Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-09-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 438.02,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 438.02
    }
  }, {
    "id": "TlK2qqvoq7Hc4Ykmxu2I",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16991876037",
      "member_cpf": "26515961839",
      "member_email": "othonamaral@ig.com.br",
      "member_id": "TfwjdDQrOJ99x5bcCjhb",
      "member_name": "Othon Amaral Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 375.4,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 375.4
    }
  }, {
    "id": "TzvARz6mBh5ZTp8XVf6D",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-09-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27997197874",
      "member_cpf": "47968109787",
      "member_email": "nogueira@cardiol.br",
      "member_id": "mCVhLTwkYpTeM5WS383I",
      "member_name": "José Roberto Coutinho Nogueira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "U3Kj4pBKYFucee6twNB2",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999826999",
      "member_cpf": "07428278368",
      "member_email": "glaucolobo@uol.com.br",
      "member_id": "shP1RBYcq5k62zfTKNPD",
      "member_name": "José Glauco Lobo Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "UAd6IWOIylrQBCERi25g",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999357424",
      "member_cpf": "65470869920",
      "member_email": "elisahollanda@hotmail.com",
      "member_id": "gAho81WNvytwDNddNFZQ",
      "member_name": "Elisa de Hollanda Calderari",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "UBoPWhR8nP92O2UMidUq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2006-10-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999099700",
      "member_cpf": "00167372882",
      "member_email": "casemiropires@gmail.com",
      "member_id": "H0G0k5AHcgylcPRf0xOa",
      "member_name": "Adilson Casemiro Pires",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-10-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "UPD7tAaiQlGH7h5njn8M",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21997947652",
      "member_cpf": "09538593472",
      "member_email": "luc.aguiar@globo.com",
      "member_id": "xxWNRacVz9HKPH8LYlpy",
      "member_name": "Luciano de Figueiredo Aguiar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "UWGe7MO2wBpbzEEjELOo",
    "data": {
      "Tid": "8041414",
      "authorizationCode": "8041414",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996088821",
      "member_cpf": "29306086849",
      "member_email": "sylvio.gandra@gmail.com",
      "member_id": "WRoQRWkcG86T4P2KhkQ9",
      "member_name": "Sylvio Matheus de Aquino Gandra",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "8041414",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "UbW103lUrU54pbJ8XTfi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "pQ4yHn5f1Au5IcE1pm0R",
      "category_name": "*Cancelados",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(61) 8123-0139",
      "member_cpf": "10103887890",
      "member_email": "cristiano_faber@hotmail.com",
      "member_id": "b5BL5n7hFvoX5yuRmaqX",
      "member_name": "Cristiano Nicoletti Faber",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "UdGDwWRsbicsaBZZ3dc1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-02-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999734009",
      "member_cpf": "08138893249",
      "member_email": "nlm@nlm.com.br",
      "member_id": "IyYYFbjLQo9xCag8hQMA",
      "member_name": "Nelson Barg",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 399.47,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 399.47
    }
  }, {
    "id": "UeoJfrakiiTXHofTNgpA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "13997353459",
      "member_cpf": "05583081805",
      "member_email": "jeffsantos65@bol.com.br",
      "member_id": "985y62GHuZKRfRSTBBIa",
      "member_name": "Jefferson Dos Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "UjXzOSYGLXCXpWbP9UNR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999869021",
      "member_cpf": "39961095804",
      "member_email": "larivetti70@gmail.com",
      "member_id": "NbntlbJxTs49lEMcL94l",
      "member_name": "Luiz Antonio Rivetti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 965.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 965.61
    }
  }, {
    "id": "UppnxaaFMtHb4ZIQmvfD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31992963485",
      "member_cpf": "77122631672",
      "member_email": "barney@uai.com.br",
      "member_id": "RKXTtRQhYcbVzqn6S09K",
      "member_name": "Marcelo Frederigue de Castro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "V4BuqpaT0YawF2NkiLai",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11964244000",
      "member_cpf": "09763430291",
      "member_email": "jalbertoporto@uol.com.br",
      "member_id": "brrO3qJbvj9cNcrY9fDW",
      "member_name": "Jorge Alberto Monteiro Porto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "V50WLtEjVJJeCNkAN8Zi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991307859",
      "member_cpf": "07170923807",
      "member_email": "volpe@marcovolpe.med.br",
      "member_id": "GNbilZsniPRA8VXIspDL",
      "member_name": "Marco Antonio Volpe",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "VFuoymCMHk0E5a3VzeJA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999790326",
      "member_cpf": "78208068934",
      "member_email": "easardeto@Gmail.com",
      "member_id": "x3LIvoafdJIv6WOjnPBi",
      "member_name": "Evandro Antonio Sardeto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "VGVbgPgB2ADQH35WCbT8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14991144923",
      "member_cpf": "19560575600",
      "member_email": "rubiobombonato@terra.com.br",
      "member_id": "z0A5dyA1Ri3IHj75mAql",
      "member_name": "Rubio Bombonato",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "VJDE9qrbPxMOETVzKPAl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2006-04-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "217116172",
      "member_cpf": "01395513700",
      "member_email": "",
      "member_id": "QvSL36smxO6a26dMp6dX",
      "member_name": "David Teles de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "VLmh0CmInpjnXAaiIQDr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86988029966",
      "member_cpf": "02275726888",
      "member_email": "paulo.sergio@hsp.com.br",
      "member_id": "cfWu4R5n27vJxULCk8yw",
      "member_name": "Paulo Sérgio Tajra Cortellazzi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "VY3VW1oOY6izMy0zGWh0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19982265555",
      "member_cpf": "24052523849",
      "member_email": "m.sumura@gmail.com",
      "member_id": "ZcmQxKWB7MEeMqoRqQEd",
      "member_name": "Miguel Hatsumura",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "VfQkJqU2uROn6b3XhWqP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999148373",
      "member_cpf": "33196370887",
      "member_email": "camilo.nt@uol.com.br",
      "member_id": "wfo5SBjD4v5jv9o5yc6w",
      "member_name": "Camilo Abdulmassih Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.6
    }
  }, {
    "id": "VzARvt1CtiWOXKNsEIw0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2007-04-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86999817070",
      "member_cpf": "04828429387",
      "member_email": "lirafilhocardio@gmail.com",
      "member_id": "Evtzg8PI0eTjewEFOEe2",
      "member_name": "José Lira Mendes Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 525,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 525
    }
  }, {
    "id": "W8G2Jw1FJyb4o5glIw5w",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2006-10-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999847419",
      "member_cpf": "67776604887",
      "member_email": "cateles@cardiol.br",
      "member_id": "TgAg9ftCzGD8A8DtOC7Y",
      "member_name": "Carlos Alberto Teles",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-10-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "WOb4HsCrENyvM30HGJ1T",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999860977",
      "member_cpf": "00234834072",
      "member_email": "gilbertobarbosa@sbccv.org.br",
      "member_id": "yP9v1YUaKffTWIhPxQui",
      "member_name": "Gilberto Venossi Barbosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "WOli5iuBvkFDZbTH4oPU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-02-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "92991268553",
      "member_cpf": "22949330282",
      "member_email": "absoeiro@hotmail.com",
      "member_id": "bEeF35AsUlHHkfNqdVLO",
      "member_name": "Alvaro Bernardo Soeiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "Wjd6Vol2CnpEQHwJa01w",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991949869",
      "member_cpf": "56854854504",
      "member_email": "lucianorapoldsouza@gmail.com",
      "member_id": "NAPjWcx02AeX9WhGu7cW",
      "member_name": "Luciano Rapold Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 320,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 320
    }
  }, {
    "id": "WkPQZ2xabcFMdtziRhYk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31984172199",
      "member_cpf": "27542017691",
      "member_email": "mtbpires@uol.com.br",
      "member_id": "rttxev3rpXKyOnDPuhjF",
      "member_name": "Marco Tulio Baccarini Pires",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "WkYxp3EqzAd2tHvnl25D",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41984297975",
      "member_cpf": "32033818934",
      "member_email": "mulinari5009@hotmail.com",
      "member_id": "0wLWqrf9hhIluobegxiE",
      "member_name": "Carlos Roberto Pereira Mulinari",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "WmSiGjggHi4aO180fzB8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-10-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11993049203",
      "member_cpf": "18711787899",
      "member_email": "galantier@terra.com.br",
      "member_id": "8iznqKkO9IG2gi0KoIdC",
      "member_name": "João Galantier",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-10-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 478.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 478.67
    }
  }, {
    "id": "WoKiUpzgo81rm0t5DP3p",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-09-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982445937",
      "member_cpf": "06092503883",
      "member_email": "estudo.edhino@gmail.com",
      "member_id": "xRKmTK0MqCgTSvkokwM5",
      "member_name": "Edhino Santos Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "X0OlmtIcAhouMN4nvNS1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "18997830629",
      "member_cpf": "07515815850",
      "member_email": "jvquiroga12@gmail.com",
      "member_id": "41KP9uZfwOqlQHkKgjPD",
      "member_name": "José Vladimir Hernan Quiroga Verazain",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "X8tBHCH6mve6esipFjUD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999091922",
      "member_cpf": "83578366668",
      "member_email": "osouzaneto@globo.com",
      "member_id": "FEwVkUiP8OJ2HkFKd3hp",
      "member_name": "Olívio Alves de Souza Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "XTHMPzhVgfQ4jK2h7Oiv",
    "data": {
      "Tid": "8041673",
      "authorizationCode": "8041673",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31991910008",
      "member_cpf": "27528952672",
      "member_email": "biocor@biocor.com.br",
      "member_id": "dysuvOcZVDGLMAp3Da6p",
      "member_name": "Mário Osvaldo Vrandecic Peredo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "8041673",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "XYLH1JgNr7kwKcEKsAEs",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-02-24T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999840224",
      "member_cpf": "50695738615",
      "member_email": "ricardo.santiago8@icloud.com",
      "member_id": "1WgUA8mZVnEvajwutfwX",
      "member_name": "Ricardo Luiz Alves Santiago",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-02-24T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "XZmGpgsxBjdrfVkPQKxB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2006-01-26T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11981212880",
      "member_cpf": "18216141866",
      "member_email": "fabiana@succi.com.br",
      "member_id": "F5J8nY64qvZ3tN9IMlS6",
      "member_name": "Fabiana Moreira Passos Succi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-01-26T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "XdEoQAvzjXNt3CaKMKs1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2001-01-01T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "8199768997",
      "member_cpf": "09024255449",
      "member_email": "mozartescobar@yahoo.com.br",
      "member_id": "opBsdUJZ6UbBGfkKC2IT",
      "member_name": "Mozart Augusto Soares de Escobar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2001-01-01T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "Xv6aH3OCbojdaXl5S0RB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999761088",
      "member_cpf": "57330700800",
      "member_email": "ldonelli@terra.com.br",
      "member_id": "kxivft58PY13s4xQK7LR",
      "member_name": "Luiz Antonio Costa Donelli",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 858.9300000000001,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 858.9300000000001
    }
  }, {
    "id": "XwJTltaghfKxxVs5GQuW",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982636633",
      "member_cpf": "01008780839",
      "member_email": "fabiojatene@incor.usp.br",
      "member_id": "BTlpXRTvn56uWDHODHh2",
      "member_name": "Fabio Biscegli Jatene",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "XzKIYQhn2vlN7liZv8QZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17996422301",
      "member_cpf": "79416810720",
      "member_email": "riocard1@hospitaldebase.com.br",
      "member_id": "HWfXQpoux3hXLdOl3UY8",
      "member_name": "Marcelo José Ferreira Soares",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Y3puBcbR0jX9ap3Yjvvo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999131477",
      "member_cpf": "02075431515",
      "member_email": "enochmeira@yahoo.com.br",
      "member_id": "fFKCfA9x3ZhWTZK97M3F",
      "member_name": "Enoch Brandão de Souza Meira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "YCe9bvyJF7YdE6zIlkpv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-09-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1381213911",
      "member_cpf": "13051475882",
      "member_email": "ayrtonbertini@uol.com.br",
      "member_id": "nnBOezqbSbcXxUtR1gWr",
      "member_name": "Ayrton Bertini Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 160,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 160
    }
  }, {
    "id": "YWe5rOB08JJ5vOetODMi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-04-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17997726560",
      "member_cpf": "70598860959",
      "member_email": "ulissesacroti@gmail.com",
      "member_id": "jF06qZ2yPJs80JF77iP5",
      "member_name": "Ulisses Alexandre Croti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "YYjTmQvwIvtrvCplXUlt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67992921330",
      "member_cpf": "22719199168",
      "member_email": "dra.sandrahelena@uol.com.br",
      "member_id": "zf0c4WJ8cyH6CQBfkp5N",
      "member_name": "Sandra Helena Goncalves de Andrade",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 274.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 274.94
    }
  }, {
    "id": "YbKQsL9SXKt05odJLDEb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00134201000",
      "member_email": "j.saadi@terra.com.br",
      "member_id": "Md0sIw2ng8D87PKLGNAk",
      "member_name": "Jair Francisco Saadi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 106.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 106.67
    }
  }, {
    "id": "Yh7bFAww4wnu7KnC6TBN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "10997059834",
      "member_email": "catani.roberto@unifesp.br",
      "member_id": "p3icsNmj9hpWGbK7yXhm",
      "member_name": "Roberto Catani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "Ykc2h7gq3xuVIkUB5vJ6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "54991227216",
      "member_cpf": "39140814068",
      "member_email": "contato@disquecg.com.br",
      "member_id": "c1pZ5bbdPvWsLRmRLPyv",
      "member_name": "Ronald Paulo Pinto Zart",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "Yo4bkACUTPxpOIHc4Zak",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999735290",
      "member_cpf": "85758418668",
      "member_email": "jeffoli@hotmail.com",
      "member_id": "NKJOwtYN17B4UdtF4ZMV",
      "member_name": "Jefferson Francisco de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "Z1V6NrP3psAL8Er7TTn5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(17) 99120-5521",
      "member_cpf": "10928317897",
      "member_email": "pcebi@uol.com.br",
      "member_id": "2IgdQlLOiravrvrlM5EH",
      "member_name": "Paulo Cesar Biagi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "Z2ySnjbLH4Vz20edKlk6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-03-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982220001",
      "member_cpf": "67019498604",
      "member_email": "amarildobatalha@yahoo.com.br",
      "member_id": "IbzV4eWdenzEfJJ8ZmvT",
      "member_name": "Amarildo Batalha de Almeida",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "ZNj06rfC7MQzWsgcxOog",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61999881191",
      "member_cpf": "41624203191",
      "member_email": "nestorsjr@gmail.com",
      "member_id": "lVGQCXM0tUwDM2YKACS6",
      "member_name": "Nestor Sabatovicz Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 399.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 399.99
    }
  }, {
    "id": "Zf3zVIk4pxzBEflRBESJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-03-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "27604748520",
      "member_email": "hdiniz.bgz@terra.com.br",
      "member_id": "vDhsaksm6UOz0ohj31tI",
      "member_name": "Haroldo Oliveira Diniz",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "ZiagNVZiPVepzf2OOzbX",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-12-23T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "98999738371",
      "member_cpf": "14829754320",
      "member_email": "josevallacerda@hotmail.com",
      "member_id": "X3m6lL9bByHNfXysQcwH",
      "member_name": "Joseval da Silva Lacerda",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-12-23T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "ZlHiADQfEIchXrptTPKl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2008-06-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "45999699696",
      "member_cpf": "81743963904",
      "member_email": "cpasserino@me.com",
      "member_id": "zqf3W25NbRy4H2RK3hYE",
      "member_name": "Carlos Heitor Passerino",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-06-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "Zpyrqr84J6nYh1uOFtJa",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61991967277",
      "member_cpf": "64004171920",
      "member_email": "ricardo.corsobsb@gmail.com",
      "member_id": "QSshnDERt5TfEgyewOjg",
      "member_name": "Ricardo Barros Corso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 472.28000000000003,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 472.28000000000003
    }
  }, {
    "id": "Zs5ruQ2ZU6G3slDZRyQT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-03-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14991163525",
      "member_cpf": "00561342822",
      "member_email": "asmartinsbtu@gmail.com",
      "member_id": "XpspvKYeD0EYGFuZbq6Y",
      "member_name": "Antonio Sérgio Martins",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "ZzQUfODwa1OeDMzV6d27",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11966205978",
      "member_cpf": "87636298872",
      "member_email": "vicavilaneto@gmail.com",
      "member_id": "kblqvbnTFyCeAbJsMaMb",
      "member_name": "Vicente Ávila Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "a3MSA0FxF9Ou1bpmigLi",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81991829339",
      "member_cpf": "04279271453",
      "member_email": "clinica_torax@hotmail.com",
      "member_id": "7HhJDxk80igqaOjtZL6e",
      "member_name": "Mário Gesteira Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "a4djy0fCMchLIc0zVOi8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2005-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999842835",
      "member_cpf": "00116785691",
      "member_email": "adriana.amoura@bol.com.br",
      "member_id": "xQnxLwfgb2OHMqi9m53J",
      "member_name": "Homero Geraldo Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.71000000000004,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.71000000000004
    }
  }, {
    "id": "a6805h7umlphu1WLRKa3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999370444",
      "member_cpf": "01579050980",
      "member_email": "dergint@hotmail.com",
      "member_id": "6kWeXheSrZjWb3Ycvc8u",
      "member_name": "André Amaral Dergint",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "aJkS7GggLlr9z4HayFrW",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61984548474",
      "member_cpf": "10296271691",
      "member_email": "avbrick@terra.com.br",
      "member_id": "oQW5u6iNISWZNqIScPem",
      "member_name": "Alexandre Visconti Brick",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "aObJcoRt5leCdMZD1LVO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999978333",
      "member_cpf": "07388527400",
      "member_email": "cox.elson@hotmail.com",
      "member_id": "qaui6CZ9QKeIeaDcwdaa",
      "member_name": "Elson Cox da Cruz Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "aPUe10xs8bzFcR5g69GL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-09-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67981119931",
      "member_cpf": "26241501100",
      "member_email": "marcus.caldas@sbccv.org.br",
      "member_id": "SNh4nm1E4nCDiNTK1AqK",
      "member_name": "Marcus Vinicius Reggiori Pereira Caldas",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "aghT9EuA82d6BriDkqRD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "48999639111",
      "member_cpf": "62659952949",
      "member_email": "evertonluzvarella@gmail.com",
      "member_id": "SLfwN6LIoGqeFa1ZXlLc",
      "member_name": "Everton Luz Varella",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "ajwBUbnFoX3Ck5a1Zwii",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16981144448",
      "member_cpf": "04263948874",
      "member_email": "rsgarbieri@uol.com.br",
      "member_id": "FosE0Q7Hd7wjyEK2oIww",
      "member_name": "Ricardo Nilsson Sgarbieri",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "akUDWLIe8UXxu6c6pQ9A",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "4191249497",
      "member_cpf": "74933442991",
      "member_email": "",
      "member_id": "ukFAwXUvNQHjEM1NputN",
      "member_name": "Robertson Massahiro Ito",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "aptGU4NOLTpie6N2DyCM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "37820680768",
      "member_email": "",
      "member_id": "TWE3ZnumiZKczT6M25sR",
      "member_name": "Joao Kiefer Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "azPK6Vb6dajQCWrkEnfu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47999844499",
      "member_cpf": "24794163991",
      "member_email": "diretoria@clamed.com.br",
      "member_id": "z4g208sklTlwQlFufGkd",
      "member_name": "Alberto Bornschein",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "b3Wgk3cS18zS5jrskGZK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "02623650730",
      "member_email": "nogueiracid@gmail.com",
      "member_id": "CdezXt4KyDc7VmNkTKJK",
      "member_name": "Cid Nogueira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "b6nPvVdbPPpI3cH3t5QJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2009-05-14T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999811797",
      "member_cpf": "00528055739",
      "member_email": "caronejunior@hotmail.com",
      "member_id": "UKjwwwgrmHifFYPy4yCg",
      "member_name": "José Carone Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2009-05-14T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "b7U3lq9ZmUCUqaLNYsFo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51998053033",
      "member_cpf": "33456526091",
      "member_email": "rubensla@terra.com.br",
      "member_id": "ihjp2weCyOgHBhYgV64h",
      "member_name": "Rubens Lorentz Araújo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "bLo24dVTYRFN4ShFodAN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "82993022052",
      "member_cpf": "24086916487",
      "member_email": "marcosgeral@yahoo.com.br",
      "member_id": "5c6zMn6WCTWow1jwdSHU",
      "member_name": "Marcos Henrique Araújo Melo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "bST6fZj1lrteG09NOJlD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "27946932634",
      "member_email": "",
      "member_id": "lJxSJPGEAwry4BewlYnO",
      "member_name": "Nilcio da Cunha Lobo Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "btVg4Rc1vACFwcPaZkfB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-01-28T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3199882051",
      "member_cpf": "63440750825",
      "member_email": "",
      "member_id": "zZUnd2Kk9xRKbaXwJ7l6",
      "member_name": "Miguel Angel Mendoza Claros",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-01-28T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.6
    }
  }, {
    "id": "byj5TQvogLnEkFcYs01l",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-04-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "44999727654",
      "member_cpf": "20201990920",
      "member_email": "apesarini@uol.com.br",
      "member_id": "Hg7BjKRljMzxCUs8GkuW",
      "member_name": "Aldo Pesarini",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "bzJaF8TY8dtxUjs20GiT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-08-01T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17981169430",
      "member_cpf": "10291080804",
      "member_email": "imc@imconline.com.br",
      "member_id": "1kAHX19TnIqnKsjQgoPs",
      "member_name": "Renata Andrea Barberio Bogdan",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-08-01T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "c2zlduw80QzyzqaVG3p9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91999817873",
      "member_cpf": "01639021272",
      "member_email": "luizabiliooliveira@hotmail.com",
      "member_id": "y99QlwgWDzYQjhXEZI8I",
      "member_name": "Luiz Abilio da Silva Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "c4WEPUNkAuAXrq8ozrhM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31988775322",
      "member_cpf": "87853167687",
      "member_email": "atena.castro@hotmail.com",
      "member_id": "GxsLjuFPKuuU3WZ2kAAQ",
      "member_name": "Atena Cipriano Castro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "c5eJ5Qe4U7Uh55vDxIlu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(11) 3286-0536",
      "member_cpf": "07289863887",
      "member_email": "clinicakncardio@uol.com.br",
      "member_id": "wYwy8VzjcKd8CPtxtZDj",
      "member_name": "Kenji Nakiri",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 858.9300000000001,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 858.9300000000001
    }
  }, {
    "id": "c6JxDkx18jWEHm9rPFWH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "32999820051",
      "member_cpf": "33228396649",
      "member_email": "jfredwhitaker@gmail.com",
      "member_id": "JQOVSY2WpJYfV51zpFSP",
      "member_name": "Joseph Fredric Whitaker",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "cCkJobYoFWD0uMR8ZtFL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999824750",
      "member_cpf": "17395275772",
      "member_email": "plmoyses@gmail.com",
      "member_id": "tXmASn9M13M6SpLC3QRO",
      "member_name": "Pedro Luiz Moyses da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "cE0LQvxJV7JtcUeTk52G",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00890560108",
      "member_email": "itacir.franceschini@sbccv.org.br",
      "member_id": "pQ0Sg0ygA1t4mBlWsa8w",
      "member_name": "Itacir Arlindo Franceschini",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "cQsbd2oXoUX8Mev8APOS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-05-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21988691060",
      "member_cpf": "82348677768",
      "member_email": "msavio@cardiol.br",
      "member_id": "UyaVScV1eqscIewX3Hl9",
      "member_name": "Marcelo Sávio da Silva Martins",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-05-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "cbOx17SaakIaeHOaUrP8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-09-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1196529860",
      "member_cpf": "02525909887",
      "member_email": "viforte@uol.com.br",
      "member_id": "rawWLS7TpbXsPFvBY70O",
      "member_name": "Vicente Forte",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 572.29,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 572.29
    }
  }, {
    "id": "cbzlA6WTFykCrkPuxWu0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2007-04-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85997543210",
      "member_cpf": "00099457334",
      "member_email": "eloaresendemartins@hotmail.com",
      "member_id": "q1chqOrnONHQo0vySUYt",
      "member_name": "João Martins de Souza Torres",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "cusEHG41TvvtjkkQfsLP",
    "data": {
      "Tid": "8041293",
      "authorizationCode": "8041293",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22981260677",
      "member_cpf": "85299952791",
      "member_email": "atbritto@uol.com.br",
      "member_id": "XnIi8LiukrCh9Orphk3s",
      "member_name": "Antonio Alexandrino de Britto Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "8041293",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "dUP8Ndmr1JEYGuWUVcPz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-07-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "13981199966",
      "member_cpf": "97446653868",
      "member_email": "angiocor@uol.com.br",
      "member_id": "5zHKJ4PYN4ewpB6ZtqRS",
      "member_name": "Miguel Luiz Cortez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-07-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "dWockWgOgHFRDbZMNRIW",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-10-14T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999728448",
      "member_cpf": "31636748953",
      "member_email": "fcosta13@mac.com",
      "member_id": "yp1SqWvrOgncLhVqTRyx",
      "member_name": "Francisco Diniz Affonso da Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-10-14T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.6
    }
  }, {
    "id": "dfxQoO4FXnQudxYUABFH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61981772662",
      "member_cpf": "14913626850",
      "member_email": "atikf@me.com",
      "member_id": "RzhhxnIjXUFxXnBViKDk",
      "member_name": "Fernando Antibas Atik",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "dixjtgFO5EIE2OEee0JR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2006-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21978459186",
      "member_cpf": "54013569787",
      "member_email": "mfmadureira@globo.com",
      "member_id": "5mRUIWpYDSkQqCIeLark",
      "member_name": "Joaquim Henrique de Souza Coutinho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "djGe9lwVgBRHzpq2apy1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999835076",
      "member_cpf": "97262838687",
      "member_email": "ernestolentz@gmail.com",
      "member_id": "btHSyGiCqp04921mSqv9",
      "member_name": "Ernesto Lentz da Silveira Monteiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "dllVYNUpoYEconEwOc3u",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47991015559",
      "member_cpf": "05920167904",
      "member_email": "dfaraco@icloud.com",
      "member_id": "ZW3kcMNvthFjoomJULHO",
      "member_name": "Djalma Luiz Faraco",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "duuypRjG7VFZMR5LBmjc",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22974007449",
      "member_cpf": "02674411775",
      "member_email": "gutierrez.darteson@gmail.com",
      "member_id": "2E1l0BMvGp16WvyrXSXw",
      "member_name": "Darteson da Silveira Gutierrez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 383.98,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 383.98
    }
  }, {
    "id": "e5gyrjJAOmb3HaDVFfHm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-06-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81988983033",
      "member_cpf": "39770800406",
      "member_email": "trindadehenriques@gmail.com",
      "member_id": "3Q36ntOtM55dgUQRU1Im",
      "member_name": "Antonio da Trindade Meira Henriques Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-06-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "e8qPsv1HhgSwVc9KVPqw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "7191867660",
      "member_cpf": "42513111591",
      "member_email": "cirurgiacardiovascular@uol.com.br",
      "member_id": "BklxmSPON2ETjiO8zQni",
      "member_name": "Luiz Claudio Nery Sampaio",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 462.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 462.68
    }
  }, {
    "id": "eL136BmEn4TuH9GMMEBH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11930085767",
      "member_cpf": "62325000753",
      "member_email": "elizabethkaratebrasil@gmail.com",
      "member_id": "1aINPSVslZ6pt9f4Nwlt",
      "member_name": "Elizabeth Sartori Crevelari",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "eM8wfUjQJWZ0JnjONMbC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14129658533",
      "member_cpf": "60140933891",
      "member_email": "dasilvajp47@gmail.com",
      "member_id": "RMgYjWDJG31XBgtBOMP2",
      "member_name": "José Pedro da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "eMYfC3BoTb3fdEeKg3xT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "03193497720",
      "member_email": "ciroherdy@uol.com.br",
      "member_id": "s28PqVSLaRVFSWCaDn0S",
      "member_name": "Ciro Denevitz de Castro Herdy",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "egX7ujJJuutIBKyH24gh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-03-25T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21996070752",
      "member_cpf": "03426823500",
      "member_email": "educicard@yahoo.com.br",
      "member_id": "WvlbjP4n4vE2zDUHxXHi",
      "member_name": "Eduardo Sérgio Bastos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-25T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "euMh7PDraj3rIKy86tuI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19997732431",
      "member_cpf": "67571328420",
      "member_email": "c.eloy@uol.com.br",
      "member_id": "JyS5Mj4rUgRaqWTRMXRx",
      "member_name": "Cledicyon Eloy da Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "fCgMb2twwEqmSPjA04ZO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-04-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1692455444",
      "member_cpf": "01608467813",
      "member_email": "amenardi@hotmail.com",
      "member_id": "Dtlj39yptHE7iog34O6n",
      "member_name": "Antonio Carlos Menardi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "fJMCroDnWBa321ns18xQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996354165",
      "member_cpf": "29529204868",
      "member_email": "dcipablo@incor.usp.br",
      "member_id": "tMtH7TBX5OeR4DXgaTF6",
      "member_name": "Pablo Maria A. Pomerantzeff",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "fPbOuapKlD0mPFvJNEFu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14997842647",
      "member_cpf": "70534462804",
      "member_email": "rubens.tb@hotmail.com",
      "member_id": "n9Z6BDJ50t5jBtPyY8Bb",
      "member_name": "Rubens Tofano de Barros",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "fRmll5JvDfinJXrju6NO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31996873071",
      "member_cpf": "91269555634",
      "member_email": "clgelape@uol.com.br",
      "member_id": "OnihPyWjPMkA6mJRMfwr",
      "member_name": "Cláudio Leo Gelape",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 403.89,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 403.89
    }
  }, {
    "id": "fVuLZMNQL6dudLjYtss6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16991726031",
      "member_cpf": "19149043897",
      "member_email": "fateno69@hotmail.com",
      "member_id": "ZnOqz81CtQjKkXQ4pVEW",
      "member_name": "Fabian Cecchi Teno Castilho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 445.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 445.61
    }
  }, {
    "id": "fYtDlzL626BRRnAJagMC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(51) 9993-0520",
      "member_cpf": "53934989004",
      "member_email": "rmenezes@terra.com.br",
      "member_id": "2MkU5Zw3qV8P5iWrLruY",
      "member_name": "Robinson Menezes do Amaral",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "fg16YafszIJTQPhjnLj8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-13T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "63999884133",
      "member_cpf": "37138383134",
      "member_email": "marcopedrolima@hotmail.com",
      "member_id": "r73KauKcaLjHGTKYG4V0",
      "member_name": "Marco Aurelio Vilela B. de Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-13T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "fsz73S9HXHCJ9HDv9OF5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91999846813",
      "member_cpf": "15512886215",
      "member_email": "albertoanijar@gmail.com",
      "member_id": "MUysaOlCWdWMEIqlqKxr",
      "member_name": "Alberto Mauro Anijar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "fwhgczDCVaUUOR89Yzfb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-04T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16981406666",
      "member_cpf": "74718916887",
      "member_email": "wvvicent@fmrp.usp.br",
      "member_id": "yF6w4gl6JsIfrJDSler7",
      "member_name": "Walter Villela de Andrade Vicente",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-04T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "g4qtaMeDG7l2pkGVRrKC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-10-06T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41992396299",
      "member_cpf": "75846276920",
      "member_email": "addumsch@yahoo.com.br",
      "member_id": "2RAcpVOvEjrF816lyq6K",
      "member_name": "Andrea Dumsch de Aragon Ferreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-10-06T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 394.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 394.67
    }
  }, {
    "id": "g7nXLNGluZPRZh5nHuI9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2181790744",
      "member_cpf": "01677733802",
      "member_email": "jcaliani@incl.rj.saude.gov.br",
      "member_id": "Iu2mlgQMAzFUhqnudT7Z",
      "member_name": "Jose Alberto Caliani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "g9rNxraF9OjdsBkPryF0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-06-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "45999724010",
      "member_cpf": "71009078968",
      "member_email": "dantaslima@uol.com.br",
      "member_id": "2lR7GS7nxTOBogDONgTc",
      "member_name": "José Dantas de Lima Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-06-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500.02,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500.02
    }
  }, {
    "id": "gDNRjkwEdhfqFuasrsIz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "32999874031",
      "member_cpf": "19352182634",
      "member_email": "ramalho@terra.com.br",
      "member_id": "XqubM1kBj6lDTwXeWbU0",
      "member_name": "Antonio Augusto Ramalho Motta",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "gEKbPHGMI4BBdJG2ckjD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999319036",
      "member_cpf": "05470298884",
      "member_email": "wciongol@uol.com.br",
      "member_id": "MEYtENCPjxZn1bN7bWVx",
      "member_name": "Wagner Ciongoli",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "gR4uF5tsNi84BU8m4iBR",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999753007",
      "member_cpf": "83912002991",
      "member_email": "rodrigo.milani@sbccv.org.br",
      "member_id": "7Y3TK2LEzeXZSlatO44l",
      "member_name": "Rodrigo Mussi Milani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "gXcUIEg710AIx3godZty",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991620252",
      "member_cpf": "00598020810",
      "member_email": "paulistapaulo@icloud.com",
      "member_id": "lJZmTvLTo0zV6v136EZo",
      "member_name": "Paulo Paredes Paulista",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "gexvxotPCn86qujATGZ1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2006-04-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "9899739133",
      "member_cpf": "02026457387",
      "member_email": "",
      "member_id": "DBnR7V7eNqYOmnfsfaIj",
      "member_name": "Horacio Lopes de O. Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 158.33,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 158.33
    }
  }, {
    "id": "gi10ZQSsQV7VE9lmCtiu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-27T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3199665265",
      "member_cpf": "62432001672",
      "member_email": "",
      "member_id": "i7GebDkBK8uNT02VfO6s",
      "member_name": "Leonardo Augusto D'avila Goncalves",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-27T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 80,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 80
    }
  }, {
    "id": "gicWpgBhuVyZfhvgg4Hq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51997149581",
      "member_cpf": "39806375068",
      "member_email": "dussin@gmail.com",
      "member_id": "N4jnPze9t3O80hWvNRsh",
      "member_name": "Luiz Henrique Dussin",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "gmstnKSCXCLstmYDNOux",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91999910033",
      "member_cpf": "05629586220",
      "member_email": "financeiro@hcordopara.com.br",
      "member_id": "n5ncSJi4i631o9bykgk6",
      "member_name": "Luiz Paulo Rangel Gomes da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "gpMgryk7dDh7H4gtBmTF",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51991718545",
      "member_cpf": "01144006015",
      "member_email": "neiarey@yahoo.com",
      "member_id": "ZZvy9XO2JeHDwcOek7oW",
      "member_name": "Nei Antonio Rey",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "guiTNekbrrs4yxYr15Jj",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2008-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999716688",
      "member_cpf": "44642423915",
      "member_email": "vcarreira@gmail.com",
      "member_id": "cf3wF7Ffe1hSPZf6HHkQ",
      "member_name": "Valdo José Carreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "h00QiYRO7TYEHfiwH9ih",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "08589097404",
      "member_email": "",
      "member_id": "DRV3oByZ0NGZGEZVlui7",
      "member_name": "Carlos Geraldo Sobral de Medeiros",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 345.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 345.6
    }
  }, {
    "id": "h3BWsJhNPjb1NcaCvzqS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "4891016251",
      "member_cpf": "17807262877",
      "member_email": "luizaelias@sbccv.org.br",
      "member_id": "kMxfaOOMI1WPEkOPQkhB",
      "member_name": "Luiza Mara Elias",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 445.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 445.61
    }
  }, {
    "id": "h3OJMdnliEwp1n3b7lvE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999819175",
      "member_cpf": "98658247791",
      "member_email": "mroldi@uol.com.br",
      "member_id": "91ogQeQylLYWR83OnYJN",
      "member_name": "Márcio Luiz Roldi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "h5ZE5Gy3BJZ2WkCqtubY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999898947",
      "member_cpf": "82054045772",
      "member_email": "jscristo@yahoo.com.br",
      "member_id": "JOAqOQxuAhdVCoPL3bj3",
      "member_name": "João Sérgio Aschauer Cristo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "hDdNHLzIVE43eGYOinB7",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85988989990",
      "member_cpf": "01662546300",
      "member_email": "waldemiro@gmail.com",
      "member_id": "hQn88eIunDaYTLht1Aak",
      "member_name": "Waldemiro Carvalho Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "hMqHBa1VmvpFYje07ZY8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86998434888",
      "member_cpf": "24042684491",
      "member_email": "paulocirurgia@yahoo.com.br",
      "member_id": "khSZMNahxQmVWpP6UC9K",
      "member_name": "Paulo Henrique Medeiros Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "hNq9Uo6Eout7NH1gCRGk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "42999722518",
      "member_cpf": "61178497968",
      "member_email": "drmarioaugusto@uol.com.br",
      "member_id": "X1lRYYq0p3EDz7d0ExB3",
      "member_name": "Mário Augusto Cray da Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "hOEbuGuRHGtHl183HWAX",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991621021",
      "member_cpf": "10760075549",
      "member_email": "calvence@yahoo.com.br",
      "member_id": "VjH0731A7UB1bYKYrRiL",
      "member_name": "Clotario Neptali C. Cueva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "hWm6pLmKxcJdoAchkGve",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2199838652",
      "member_cpf": "30576768715",
      "member_email": "vandercorteze@hotmail.com",
      "member_id": "8D1ETJNdSlv7zJebPeaB",
      "member_name": "Vander Vinicius Costa Corteze",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "hb7u5opuyZW7iQ2eHr6t",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-04-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2199743616",
      "member_cpf": "56913184700",
      "member_email": "",
      "member_id": "iL1LZxAT2bnu3GBtcoBd",
      "member_name": "Sergio Vieira Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "hfZUi5qeAWhkwFvNPGC5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-11-30T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "43996069606",
      "member_cpf": "10383903890",
      "member_email": "robertogalhardo@globo.com",
      "member_id": "GIPCggnaV6yPlV46tIWr",
      "member_name": "Roberto Galhardo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-30T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "hrS8ecf94MLH8ZEhQnC7",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-04-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999717355",
      "member_cpf": "06086633878",
      "member_email": "tamaki@uol.com.br",
      "member_id": "kEiv79NPvrQOCIJs9nGK",
      "member_name": "Wagner Tetsuji Tamaki",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "hroBsVbyVxhlriSaovdc",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "46988012962",
      "member_cpf": "58362010991",
      "member_email": "paulogiublin@gmail.com",
      "member_id": "zhA7Pb6BCAp6Ka9T5EbQ",
      "member_name": "Paulo Roberto Giublin",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "htbe5HepIvc3NpleHPxb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-11-30T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "9551583801",
      "member_cpf": "16999401004",
      "member_email": "knabben@osite.com.br",
      "member_id": "qD946WigWg2nwqEVko6S",
      "member_name": "Werner Knabben Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-30T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 86.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 86.68
    }
  }, {
    "id": "hu5M9Wla2hX2oKStGojb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999340678",
      "member_cpf": "12208421841",
      "member_email": "abenicio@uol.com.br",
      "member_id": "CZSkIRMpYqpahrCWuVp7",
      "member_name": "Anderson Benício",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "huXWMX7vQxXJYl0gRnQ1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41988011407",
      "member_cpf": "53383265900",
      "member_email": "victor.bauer.junior@gmail.com",
      "member_id": "WwQ0apN35rijenFwGt9i",
      "member_name": "Victor Bauer Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "i5J0CBZ6QeEt8vw2Pvy5",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85991215675",
      "member_cpf": "16427120867",
      "member_email": "mejia.juanc@gmail.com",
      "member_id": "v931elE9XIZJxcOGdNS4",
      "member_name": "Juan Alberto Cosquillo Mejia",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "iIqJrBJUjqLUrAfpswb9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "98999716474",
      "member_cpf": "04044800391",
      "member_email": "khorigoshi@gmail.com",
      "member_id": "srefRc3Z5RDK1Ks9TZge",
      "member_name": "Raimundo Reis Rodrigues",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "iS0qcKvZ0H9cC3hXUFAN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-08-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(11) 2295-7091",
      "member_cpf": "12850713449",
      "member_email": "maflira@cardiol.br",
      "member_id": "AH09t9UrCFIaSelIvaxw",
      "member_name": "Marcos Antonio de Farias Lira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-08-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "iTz4F2uAVcQXYKfMILP7",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "96807423853",
      "member_email": "",
      "member_id": "JDaAgxFH2R4GHOHuHM1j",
      "member_name": "Tania Aparecida Martins da Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "iYFHqziYP1zSKEvCYbjA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2006-06-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11995025077",
      "member_cpf": "01053866852",
      "member_email": "ferandraguedes@uol.com.br",
      "member_id": "afsnjBQP9NpJnPtrRxrt",
      "member_name": "Fernando Andrade Guedes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-06-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "ibbPnTGSNcC8QB3oFMxo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-09-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17997910905",
      "member_cpf": "83840958849",
      "member_email": "marcoszaiant@hotmail.com",
      "member_id": "Bh2T6Tx2CMT6z1kNLaSd",
      "member_name": "Marcos Zaiantchick",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "ic7UHUyHEKwmk2BY2Qrn",
    "data": {
      "Tid": "1726",
      "authorizationCode": "1726",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(51) 99256-1835",
      "member_cpf": "88878040010",
      "member_email": "rafawrey@gmail.com",
      "member_id": "eIzqT8V6SF6gHpilL5Id",
      "member_name": "Rafael Antonio Widholzer Rey",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "1726",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "icwzpnkMhstlDuo9Abeo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-11-30T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "5599721225",
      "member_cpf": "17505313053",
      "member_email": "lbmoraes@cardiol.br",
      "member_id": "3vR6RrdfXVEW0TopkPEG",
      "member_name": "Luiz Braganca de Moraes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-30T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 86.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 86.68
    }
  }, {
    "id": "imiHZuOyjZy9y8OCk2zl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-02-14T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "48999732211",
      "member_cpf": "59156481934",
      "member_email": "sergioalmeida4370@gmail.com",
      "member_id": "1sRBX2OvshSSNxP35bWs",
      "member_name": "Sérgio Lima de Almeida",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-02-14T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "iopn7Zl7i5lVzoU0V3Va",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-04-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81999764545",
      "member_cpf": "10902210297",
      "member_email": "melorayol@uol.com.br",
      "member_id": "5q4e8ZV6KSSHFKZhPVit",
      "member_name": "Sérgio da Costa Rayol",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "ipnDdfRgqxqxyucBVNLQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999508821",
      "member_cpf": "98877399872",
      "member_email": "bhumbertob@terra.com.br",
      "member_id": "EVanJyve8AKyTiOCmS5q",
      "member_name": "Humberto Benedetti",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "isQS5GVsfDMRx7P4TbdT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "43999917743",
      "member_cpf": "97971910959",
      "member_email": "gualter.jr@hotmail.com",
      "member_id": "I076SE8fqlbqx6JUjo7a",
      "member_name": "Gualter Sebastião Pinheiro Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "istuf3HROZpmRJMlaB0k",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62981592585",
      "member_cpf": "23842865104",
      "member_email": "maleixo@cardiol.br",
      "member_id": "jDgN71xCqp6maPjVcl6s",
      "member_name": "Marcos Vargas Aleixo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.61
    }
  }, {
    "id": "izTDw0H2596tmkJqgL3T",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "18991224275",
      "member_cpf": "14638967191",
      "member_email": "hpocoferreira@gmail.com",
      "member_id": "tWO7LeZYh8GhUSE72wbe",
      "member_name": "Hélio Poço Ferreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "j029AsMDJ6ZZ2prfX3Hz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999726161",
      "member_cpf": "13517279234",
      "member_email": "wilson@cardiol.br",
      "member_id": "G7lcUh6ajYPZpR2Xf60Y",
      "member_name": "Wilson Luiz da Silveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 367.73,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 367.73
    }
  }, {
    "id": "j4Gxd1JRhN4GkMwEfCcB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999792789",
      "member_cpf": "88816931949",
      "member_email": "soncini7@gmail.com",
      "member_id": "5YxlBHAfgpiuHI67JHKZ",
      "member_name": "George Ronald Soncini da Rosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "jCqeTEaHLcg5xEYfxk3f",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-02-16T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51981662666",
      "member_cpf": "49261002072",
      "member_email": "mcsales@terra.com.br",
      "member_id": "4l3989WUqEkyDScf47UK",
      "member_name": "Marcela da Cunha Sales",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-02-16T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "jFWPeMgxMDv86ZXE5Xip",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-06-13T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61999798080",
      "member_cpf": "06339980287",
      "member_email": "candidormgomes@gmail.com",
      "member_id": "ijTbb3nOSchmNMLsSHAm",
      "member_name": "Cândido Rodrigues Martins Gomes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-06-13T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.61
    }
  }, {
    "id": "jLbHZ4cXLJoHFiAnvzjT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11963656410",
      "member_cpf": "67339867953",
      "member_email": "drpoffo@institutopoffo.com",
      "member_id": "VfFO3FTnWduNYdCq9nCY",
      "member_name": "Robinson Poffo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "jPh7BDFzSXNbTvNYGRkY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999866749",
      "member_cpf": "00454507810",
      "member_email": "rcosta@incor.usp.br",
      "member_id": "akUPKrpWe1E9PFpHU5Bm",
      "member_name": "Roberto Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "japsjm0RBMHR9aIAkJjz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-26T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17997756413",
      "member_cpf": "09260489881",
      "member_email": "rinaldocsantos@uol.com.br",
      "member_id": "PO95XmjXq64F5MrLhWnl",
      "member_name": "Rinaldo Costa Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-26T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "jduPQZYCBhxepr4BSOSb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2009-09-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6199882615",
      "member_cpf": "42316502415",
      "member_email": "",
      "member_id": "1gwQCVVxOsiyb5OzRvlc",
      "member_name": "Jose Joaquim Vieira Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2009-09-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "jhd0cjN9yzpumc51AsNw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62984174376",
      "member_cpf": "18584080910",
      "member_email": "alekd@cardiol.br",
      "member_id": "zPBATAIElUvAmJMONryH",
      "member_name": "Aleksander Dobrianskyj",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "ji4YUMmpiaihwwvwKFe0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999945028",
      "member_cpf": "20979002087",
      "member_email": "aldemir.voy@gmail.com",
      "member_id": "ORGHnjx30jkTlNMco42Z",
      "member_name": "Aldemir José da Silva Nogueira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "jkrbB3eRHCEIKS34N46e",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999986588",
      "member_cpf": "46530762604",
      "member_email": "joscarbrito@globo.com",
      "member_id": "mWDp9cm6qybJnwRrh4Fr",
      "member_name": "José Oscar Reis Brito",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "jxc76J1NtGL3JeuZiAYS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83991063079",
      "member_cpf": "16109325449",
      "member_email": "basilioserrano@hotmail.com",
      "member_id": "6mRtSZrAOh6dPNn5b2lM",
      "member_name": "Basílio Serrano de Sousa Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "k0IwLDdQcQOebT1j65Wk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27999820101",
      "member_cpf": "97805106720",
      "member_email": "casancio@uol.com.br",
      "member_id": "7nfeqARBqXRZp3KWvKWI",
      "member_name": "Carlos Alberto Sâncio Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "k0qqYIDYfToKxww5Ne5R",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2005-04-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "05453020300",
      "member_email": "memoriajunor@bol.com.br",
      "member_id": "BNVtjHBfCu2pzviQJZa9",
      "member_name": "Jose Maria F. Memoria Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-04-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "kAaVmhALMrpMb5FD9Nym",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999824659",
      "member_cpf": "61849928800",
      "member_email": "ccmc-cardio@uol.com.br",
      "member_id": "xk3y7wSVAg9AaOvoRqtm",
      "member_name": "João Bosco Pellattiero de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "kaLYxXJUHdTnaYbnpV61",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "92981115079",
      "member_cpf": "57281459734",
      "member_email": "drluizclima@gmail.com",
      "member_id": "bQEmOLASoH9Vw4MlY9va",
      "member_name": "Luiz Carlos de Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 401.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 401.94
    }
  }, {
    "id": "kecmVobkZTfO3P7C2dbn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(86) 3233-6840",
      "member_cpf": "28405234420",
      "member_email": "arlene.goes@uol.com.br",
      "member_id": "wJYmhgqjZVCo02OR7UJq",
      "member_name": "Luiz Otávio de Goes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "kmXmynXhAyyRrT5Itess",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999825875",
      "member_cpf": "06875659875",
      "member_email": "gvcividanes@uol.com.br",
      "member_id": "fZynOkmGMBjSpyN6NcgE",
      "member_name": "Gil Vicente Lico E Cividanes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "koQJ1GIEdaESrTlCh738",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-11-29T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999731081",
      "member_cpf": "11090311818",
      "member_email": "hectorbc@cardiol.br",
      "member_id": "tZLXMCEyTS7JLIOEvK81",
      "member_name": "Hector Bedoya Copello",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-29T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "kyP5JMWNzEKxWwZ0NIN1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47999892867",
      "member_cpf": "11412054087",
      "member_email": "motanjm@gmail.com",
      "member_id": "ExHE0G6741TdWU1tPUWp",
      "member_name": "Newton José Martins Mota",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "lBDDEPNuUJgCN9n6X33y",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17991420608",
      "member_cpf": "12181012881",
      "member_email": "reginaldopcastro@yahoo.com.br",
      "member_id": "ZpdrdiUdGtRbKeEx2cbM",
      "member_name": "Reginaldo Pereira de Castro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "lJdnJUariYIJPozqISwP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-04-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67999066464",
      "member_cpf": "26387409772",
      "member_email": "jjazbik@hotmail.com",
      "member_id": "3oldrGvy8MfxPFUkmFt0",
      "member_name": "João Jazbik Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-04-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.61
    }
  }, {
    "id": "lLfblbcPAXvzRRomtO4j",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2006-04-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21993232836",
      "member_cpf": "06515222858",
      "member_email": "celioromatheus@gmail.com",
      "member_id": "avuGVtLx5mNA2t1PPGfF",
      "member_name": "Célio Matheus",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "lNR7mGyy6KI1ih6niOr8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-08-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31987257116",
      "member_cpf": "28811216834",
      "member_email": "gomes@servcor.com",
      "member_id": "Ca6JPfcQVSMJZs8C3z4h",
      "member_name": "Otoni Moreira Gomes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-08-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "lNlUZkSfTYxPnRV77HK3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999681423",
      "member_cpf": "00598011820",
      "member_email": "monicabento@uol.com.br",
      "member_id": "lPdDpW8VpNzGAyTTca5D",
      "member_name": "Luiz Carlos Bento de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "lZeTOkUVZISkYOrCiRie",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14991515562",
      "member_cpf": "84488425704",
      "member_email": "zildomard@yahoo.com",
      "member_id": "N5AAv2hdZuSVbLIshWhn",
      "member_name": "Zildomar Deucher Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 360.01,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 360.01
    }
  }, {
    "id": "lcC23XTOjJsKndMHRAr3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "48999723998",
      "member_cpf": "09285741991",
      "member_email": "jaurocollaco@yahoo.com.br",
      "member_id": "E4ySR2XTdGbe98l7BKVb",
      "member_name": "Jauro Collaçoo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "lfJ4XDipdQPswXCjWvGM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-02-15T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14997687037",
      "member_cpf": "11416007814",
      "member_email": "siderval@unimedmarilia.com.br",
      "member_id": "JHmo2nq663HxeqweGVoy",
      "member_name": "Siderval Ferreira Alves",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-02-15T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "li9Xj1VRkO2zedmSNYYt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-04-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "82991166043",
      "member_cpf": "55615031468",
      "member_email": "gamacasado@hotmail.com",
      "member_id": "lazI9dv2fDrrab4Ch42N",
      "member_name": "Hemerson Casado Gama",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "lkR0wsVUVC8RRhhSeZ6u",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-04-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21996445559",
      "member_cpf": "02036917763",
      "member_email": "albertofco@yahoo.com.br",
      "member_id": "CZZNrNAdW3zE7Aa0PrCd",
      "member_name": "Alberto Francisco Valencia Vera",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "lto2ng7KrCFAajSZOoAC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-09-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999835900",
      "member_cpf": "16338472334",
      "member_email": "fcarlos@cardiol.br",
      "member_id": "XMB32IpinQbIy4rzFGXw",
      "member_name": "Francisco Carlos Costa Sousa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 324.63,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 324.63
    }
  }, {
    "id": "lxZa4dnZEr63hmbQy77n",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11976057180",
      "member_cpf": "15182425880",
      "member_email": "carlosmbrandao@terra.com.br",
      "member_id": "Nci7AIXDEKQ27UR2Ryfu",
      "member_name": "Carlos Manuel de Almeida Brandão",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "mOUjcN6sPIEnKFnOTmNG",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67981129986",
      "member_cpf": "36845442134",
      "member_email": "carlosdorsa@uol.com.br",
      "member_id": "gHPnSgLK8Fps9GKjZ5yh",
      "member_name": "Jose Carlos Dorsa Vieira Pontes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "mPZrg7MSM0mKNFq10beD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "00176575715",
      "member_email": "joao.florencio@globo.com",
      "member_id": "7FB81czxM47fLAFkompx",
      "member_name": "João Florencio Palmeira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "mat1a6TRSw17olpPgRJl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11 996269931",
      "member_cpf": "03234043833",
      "member_email": "paulopego@incor.usp.br",
      "member_id": "3YKHsRROT0UV32P4W7Wm",
      "member_name": "Paulo Manuel Pêgo-fernandes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "mes5G63GSsnWDkkQdp99",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-09-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "48991466303",
      "member_cpf": "70939110997",
      "member_email": "mbonin69@gmail.com",
      "member_id": "0ycfymjme8WqPqJDP22a",
      "member_name": "Marcos Bonin",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 390.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 390.94
    }
  }, {
    "id": "mgzvaExFk1Dv1AVonPou",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-25T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91981579981",
      "member_cpf": "02397544253",
      "member_email": "manoelmaneschy@intercor.com.br",
      "member_id": "gtnrr0TfETnKy7I3VOUX",
      "member_name": "Manoel Araujo Maneschy",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-25T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "mlLrlBg83i3RCwDecWGd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11992722201",
      "member_cpf": "61983454834",
      "member_email": "arturlj@uol.com.br",
      "member_id": "4kKyf4tI2Mrw1X4Uvhos",
      "member_name": "Artur Lourenção Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "mrDPbkse7silGn2SzfGu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-02-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71999773618",
      "member_cpf": "61134570520",
      "member_email": "rilsonfm@uol.com.br",
      "member_id": "QPzi35A4UlFWMeX8FhSu",
      "member_name": "Rilson Fraga Moitinho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "mxdtBzsNSKNOdNKWja78",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-03-21T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "84999829807",
      "member_cpf": "15459535468",
      "member_email": "jjmamaral@yahoo.com.br",
      "member_id": "Y90o4YcoL3yo2DzNQf0g",
      "member_name": "Josalmir José Melo do Amaral",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-21T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "mzEEhavZOmwO5RJjkxDU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "6299712458",
      "member_cpf": "35625848904",
      "member_email": "costaecosta@brturbo.com.br",
      "member_id": "RUKyED3t25Rr0uaVO4hX",
      "member_name": "Marcos Hyczy da Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 274.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 274.94
    }
  }, {
    "id": "n44IYMXE3HsvMKRBMXkk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11973970387",
      "member_cpf": "15310293884",
      "member_email": "j.breda@uol.com.br",
      "member_id": "621e4C7ZwE6d4382W1Xm",
      "member_name": "João Roberto Breda",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 445.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 445.61
    }
  }, {
    "id": "nCxl7JtCRA2WfmyO5tfE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "84996019509",
      "member_cpf": "48160385404",
      "member_email": "daniel.waldo@yahoo.com.br",
      "member_id": "IFFBOlR2QfHhXOk6FbdY",
      "member_name": "Waldo Emerson Pinheiro Daniel",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "nSFj7yKFiD3WT42XbfeE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999750689",
      "member_cpf": "80629784868",
      "member_email": "chacentromed@gmail.com",
      "member_id": "KYy0pxYmexykHXbIG17N",
      "member_name": "Sang Joon Cha",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "nZOTSXi6JJK3hzkIUPWJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "44999720475",
      "member_cpf": "54028531934",
      "member_email": "altyszka@uol.com.br",
      "member_id": "0Fk2miJzeZizbYVobksq",
      "member_name": "André Luiz Tyszka",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "neH8BwAB8sWp5rE9Qx7V",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-02-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21998597585",
      "member_cpf": "10210890797",
      "member_email": "gladystonsouto@gmail.com",
      "member_id": "1BetgqwuRKm3nXOCDSdk",
      "member_name": "Gladyston Luiz Lima Souto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-02-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "neJIJPpI07VKsGtLgi8M",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16999920869",
      "member_cpf": "25794892315",
      "member_email": "franmoreira@conjunturabrasil.com.br",
      "member_id": "HWMRxbVpf4S0EkTfBuPo",
      "member_name": "Francisco Fernandes Moreira Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "nfeSagoWpeao6saZ3Grq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2005-01-11T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2299822440",
      "member_cpf": "37426168700",
      "member_email": "p.jazbik@hotmail.com",
      "member_id": "0KICc5F5PO7Q4ZNvKbYP",
      "member_name": "Paulo Jazbik",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-01-11T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "niFOuOSWnEItoL9uyxHn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "pQ4yHn5f1Au5IcE1pm0R",
      "category_name": "*Cancelados",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(51) 9981-6879",
      "member_cpf": "63771659000",
      "member_email": "juglanspoa@gmail.com",
      "member_id": "BUR0AgtKMdDsnuAA3R0x",
      "member_name": "Juglans Souto Alvarez",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "nstS70TbwY32nLKJqTr0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999721191",
      "member_cpf": "16786475949",
      "member_email": "prbrofman@gmail.com",
      "member_id": "MNTt0PEzSWSglNXPwjY3",
      "member_name": "Paulo Roberto Slud Brofman",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "nwQdnIsapErUHNys6aTH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "34999120003",
      "member_cpf": "08276457835",
      "member_email": "cassio@sgarbi.biz",
      "member_id": "KCOdHBIaRXX9LYAl7cEJ",
      "member_name": "Cassio José Sgarbi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "nyzbY0sjEUOJ1fmyshXl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "38999867417",
      "member_cpf": "56433565620",
      "member_email": "flaviodonizetegoncalves@gmail.com",
      "member_id": "AyPWyjglsR4mrVNdrhUc",
      "member_name": "Flávio Donizete Gonçalves",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 470.13,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 470.13
    }
  }, {
    "id": "nzE2xX6GTYCVbBb98vtX",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2788183156",
      "member_cpf": "57747474768",
      "member_email": "wtmjr@hotmail.com",
      "member_id": "1mhEDaP5mziWFg6bbdR4",
      "member_name": "Walter Teixeira de Mello Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 398.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 398.67
    }
  }, {
    "id": "nzz4qQGLCHT9h6g9Tg3T",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1184296662",
      "member_cpf": "39137414887",
      "member_email": "",
      "member_id": "k9RdptzqtKfwFCYHrwwZ",
      "member_name": "Roberto Tomikasu Takeda",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "o5dREWBNdi2D6BoSRood",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999944530",
      "member_cpf": "04332296753",
      "member_email": "celsogarcia@globo.com",
      "member_id": "9FOzbZPdsyyy323qKnOO",
      "member_name": "Celso Garcia da Silveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "oCutfkbY7kX80nyY1uJ3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2008-07-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996875114",
      "member_cpf": "02140238850",
      "member_email": "myrianguadalupe.moreira@gmail.com",
      "member_id": "ZcAPo7NqK7omUdKVXPSx",
      "member_name": "Myrian Guadalupe Moreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-07-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "oGyAHxS0HLd3qzv6ZBBp",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2006-04-07T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86999824007",
      "member_cpf": "21769877304",
      "member_email": "eucmonteiro@yahoo.com.br",
      "member_id": "4aLDxOmSRLFYsYObPnw1",
      "member_name": "Eucário Leite Monteiro Alves",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-04-07T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "ocRFeB5pG7BVq3DTTDs0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14996521992",
      "member_cpf": "01895957877",
      "member_email": "herculesbongiovani@outlook.com",
      "member_id": "I5CCXyO9h2BorZRDDKzC",
      "member_name": "Hercules Lisboa Bongiovani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Cheque",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Cheque",
      "value": 500
    }
  }, {
    "id": "ocq9J3oJcf7Y3z04uyUN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2006-02-10T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91991443448",
      "member_cpf": "28041798268",
      "member_email": "nevesmarcondes@gmail.com",
      "member_id": "vzIXdaF9c1PO86u7aNwA",
      "member_name": "Marcondes Tavares Neves Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-02-10T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "ofkBSkjFkteFxz2x4t4e",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83987121141",
      "member_cpf": "87302250430",
      "member_email": "gadelhapaty@hotmail.com",
      "member_id": "Hj1NU91LqLlm59V09jpj",
      "member_name": "João Bosco Ferreira Gadelha",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "oumfonVjMBaF7W78TCts",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2006-02-23T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "65999812813",
      "member_cpf": "04698390826",
      "member_email": "jarbas@clinicaferrari.com.br",
      "member_id": "tTBqk5Cr1MrfBF0Pl5ZR",
      "member_name": "Jarbas Ferrari Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-02-23T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 300,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 300
    }
  }, {
    "id": "ouody9dtCUb7JAEACZU4",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11993758386",
      "member_cpf": "19813477806",
      "member_email": "fabioantoniogaiotto@gmail.com",
      "member_id": "xqTX7GiqTIBdSS1966cZ",
      "member_name": "Fabio Antonio Gaiotto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "oy1aDNQcnkwqZxw9Gz3D",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91999810561",
      "member_cpf": "04255364249",
      "member_email": "kourymaues@uol.com.br",
      "member_id": "mwwZlByv9CyisLCrx48e",
      "member_name": "Haroldo Koury Maués",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "p3iQzObCN64MSD3KPf8E",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71999841253",
      "member_cpf": "09366261515",
      "member_email": "agenoribeiro@gmail.com",
      "member_id": "i0TI2EeVtfPSe0xVOTuP",
      "member_name": "Agenor Ribeiro de Jesus Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "p5AvMVyGiv5FG3B8hlni",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "01531506887",
      "member_email": "",
      "member_id": "wVzYBz0AdeBvHlveq4V7",
      "member_name": "Albert Amin Sader",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 106.67,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 106.67
    }
  }, {
    "id": "pE3h7LJUeZR5po0kCYnm",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16999923022",
      "member_cpf": "14088967887",
      "member_email": "azair.brasil@gmail.com",
      "member_id": "QpmAtoz0hb5wO1ygr2BV",
      "member_name": "Jose Carlos Franco Brasil",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "pEeas6HhrcO98ER0lHjq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61999688200",
      "member_cpf": "31649254172",
      "member_email": "leonardoelima@terra.com.br",
      "member_id": "M1CxP5XmF4IBQhVslNGb",
      "member_name": "Leonardo Esteves Lima",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "pFTmMJoAgNTTGQoRzEyX",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "36394963704",
      "member_email": "",
      "member_id": "ZMDKFHd62oeQAM9RMINq",
      "member_name": "Ricardo Jose de Almeida Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "pWQV9o5ZPInNzHKykDEN",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19996569171",
      "member_cpf": "65758552615",
      "member_email": "oliveira.ppaulo@gmail.com",
      "member_id": "ojrNfdCrf2Uz2YnDMO2Q",
      "member_name": "Pedro Paulo Martins de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "pYezzfH51hA2sUEcab8q",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1182617247",
      "member_cpf": "08238124808",
      "member_email": "",
      "member_id": "qnqOSGs77PLocVZDMA6w",
      "member_name": "Jaime Ignacio Jaramillo Altamirano",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "paoF8tFs7U1J5HDrtuDo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11998107032",
      "member_cpf": "16737679668",
      "member_email": "marcus.carvalho@sbccv.org.br",
      "member_id": "TLWgzY3AllxcdbUxbqBx",
      "member_name": "Marcus Vinicius Henriques de Carvalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "pipO2PA5oTpAsGgTZOgA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3199846912",
      "member_cpf": "38203944868",
      "member_email": "rabelo.bh@terra.com.br",
      "member_id": "wAvtT7An5AHwBNJCgluW",
      "member_name": "Raul Correa Rabelo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "pjAZBs4EHSTUFmDZs3Ba",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-12-21T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16997664158",
      "member_cpf": "15974750845",
      "member_email": "lafajuniordireito@yahoo.com.br",
      "member_id": "KtjxvX4UB2m9N80WUAVa",
      "member_name": "Lafaiete Alves Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-12-21T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "pmcp6OImqe5CiYHi6lZD",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19997253335",
      "member_cpf": "02770664840",
      "member_email": "orlandopetrucci@mac.com",
      "member_id": "1JKKeQ3W68Z6MjC2Ato3",
      "member_name": "Orlando Petrucci Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "pswCAEf1VKSBABK2j2JI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1182816662",
      "member_cpf": "56298587691",
      "member_email": "jose.mussi@sbccv.org.br",
      "member_id": "QZfw4sluuAJPVF9gRNW8",
      "member_name": "Jose Carlos Mussi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 394.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 394.68
    }
  }, {
    "id": "qG8iH8ipdBwxt2lYbWEz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-02-13T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11 9 9986-4423",
      "member_cpf": "10560432887",
      "member_email": "antoninhoarnoni@gmail.com",
      "member_id": "sCxPEPY5PMvvH5mhhEaE",
      "member_name": "Antoninho Sanfins Arnoni",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-13T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "qIPR20hq2cT2cuyn4t9k",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31993111215",
      "member_cpf": "31220150649",
      "member_email": "marcoasalum@ig.com.br",
      "member_id": "vngnzTifAC7UkCqLXzYO",
      "member_name": "Marco Antonio Salum",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "qJrN5lxhMKkwl015UwZI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999770169",
      "member_cpf": "69696276915",
      "member_email": "psoltoski@gmail.com",
      "member_id": "KCwxFooT6D3a10j905PQ",
      "member_name": "Paulo Roberto Soltoski",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "qKr58SgwDgeQRTZWk0EI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999028316",
      "member_cpf": "13594604896",
      "member_email": "taniguchi@sbccv.org.br",
      "member_id": "HTKc2MqiLu9LK2mfgmaj",
      "member_name": "Fábio Papa Taniguchi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 445.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 445.61
    }
  }, {
    "id": "qXN509Bi5hwOrNQWuksw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-04-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996256260",
      "member_cpf": "26914948291",
      "member_email": "magalyarrais@gmail.com",
      "member_id": "8vWrWlQ4IZxCMIoSQAF5",
      "member_name": "Magaly Arrais Dos Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 399.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 399.61
    }
  }, {
    "id": "qYUAeJVJ819rQHXLllHu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19992196630",
      "member_cpf": "02827466848",
      "member_email": "abraoabdalafilho@hotmail.com",
      "member_id": "KW68eXKEc7qSTspsZEXm",
      "member_name": "Abraao Abdala Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "qewRFvqh8Kf17Yv8Evw0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "24999997442",
      "member_cpf": "01819322882",
      "member_email": "amauryviotti5@gmail.com",
      "member_id": "e1rLQLsQRdnixHQnaxRZ",
      "member_name": "Luiz Amaury Portugal Viotti Junior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "qs8U1lRssQjBSEr9l7f3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2199958151",
      "member_cpf": "48720801734",
      "member_email": "alvarobarde@hucff.ufrj.br",
      "member_id": "6ZS5ysLI7OMagdg1oNNI",
      "member_name": "Alvaro Barde Bezerra",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "qtZtvtbyU1ZZvUAAX4Tv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19981816009",
      "member_cpf": "01692710800",
      "member_email": "ejsancho@outlook.com",
      "member_id": "DpH5TQugbS6oNspX4KJg",
      "member_name": "Eduardo José Vanti Sancho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "r1xcH2HEjy1N13OUIet2",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "pQ4yHn5f1Au5IcE1pm0R",
      "category_name": "*Cancelados",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21997118247",
      "member_cpf": "09148965700",
      "member_email": "jcarlos_souto@hotmail.com",
      "member_id": "UFA3kAe3dbY4h5t9e80T",
      "member_name": "João Carlos de Moura Souto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "rCfyrLFSOX2KAGisGGtZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "27997877072",
      "member_cpf": "00807912719",
      "member_email": "fabioreis5423@gmail.com",
      "member_id": "YfyD7EKDEc9SAHu4zPol",
      "member_name": "Fábio José Dos Reis",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "rM2tr86L4FK4LgZBAofE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "83993354187",
      "member_cpf": "57649332420",
      "member_email": "dvaldeban@gmail.com",
      "member_id": "lKL3gK21gBV3hO3MzcLC",
      "member_name": "Valdeban Dantas da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 160,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 160
    }
  }, {
    "id": "rMC2l5CNeWKATzJbLYLk",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81999960194",
      "member_cpf": "00000582468",
      "member_email": "cmoraes@uol.com.br",
      "member_id": "XIiCKzFcNgqxSFGVNbHT",
      "member_name": "Carlos Roberto Ribeiro de Moraes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 542.26,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 542.26
    }
  }, {
    "id": "rMTx19z89Pyu7voQFlLt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "32243391600",
      "member_email": "recoliveira@ig.com.br",
      "member_id": "pffvWTYrAFTLDSpWAgLu",
      "member_name": "Renato Nunes Fagundes de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "rWIIGej7JQizCloYHjwx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999936737",
      "member_cpf": "63348845068",
      "member_email": "gibranahmad@hotmail.com",
      "member_id": "XBgKFGf4RUCYwn7tcFGY",
      "member_name": "Gibran Rashad Muslih Ahmad",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "rZcmVck6Lbh3ozBsCuOb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21988832652",
      "member_cpf": "01599190702",
      "member_email": "alexandre.siciliano@gmail.com",
      "member_id": "zKCTSoxlPaQi0xoTBzQV",
      "member_name": "Alexandre Siciliano Colafranceschi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "rgMcGntNmRXJimDzqYmQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991275000",
      "member_cpf": "24172693504",
      "member_email": "zazakraych@terra.com.br",
      "member_id": "D2cTwd9pATkdowb98vkW",
      "member_name": "Nadja Cecília de Castro Kraychete",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "rmfZ5wan0qimzhYTJfWt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-05T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61983172335",
      "member_cpf": "08047691848",
      "member_email": "glaucopina@hotmail.com",
      "member_id": "o8wQFC5EjxlJbAznGP88",
      "member_name": "Glauco Kalil da Silva Pina",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-05T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 401.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 401.61
    }
  }, {
    "id": "rt67Y6wFXSjSvfZ7d4dA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-02-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999861073",
      "member_cpf": "54384176791",
      "member_email": "luiz.henrique@carvalho.med.br",
      "member_id": "yLLDrClleZkpmCB5xKi3",
      "member_name": "Luiz Henrique Pamplona Côrte Real Carvalho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "rxaADN4oVd2qTDAVZr6j",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "5199924963",
      "member_cpf": "54532655072",
      "member_email": "luciane.barreneche@terra.com.br",
      "member_id": "ynINGOUE968Z6B4j4TQG",
      "member_name": "Luciane Barreneche Narvaes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "s0BZj5pvDMevzzRF89xZ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "43999911234",
      "member_cpf": "32466714949",
      "member_email": "icc@sercomtel.com.br",
      "member_id": "pXPepXyvrWzfXzGqUCWA",
      "member_name": "Kengo Baba",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "s7y9XUDI1RbLa1zPoOOq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11983505289",
      "member_cpf": "63796104649",
      "member_email": "ronaldombueno@gmail.com",
      "member_id": "XyWEdLxho1ehV3y7f4xe",
      "member_name": "Ronaldo Machado Bueno",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "sH09hpQ9TytSRcX2fzI2",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-04-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "98999739699",
      "member_cpf": "42788048300",
      "member_email": "rvnina@terra.com.br",
      "member_id": "VBZgvFDBMbMvqvUcyrQ6",
      "member_name": "Vinicius José da Silva Nina",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "sIZXqa9jf9r7PPD2XZKn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996073905",
      "member_cpf": "07784312822",
      "member_email": "flaviopst@uol.com.br",
      "member_id": "CGoVFR2PcIlkn5UmVpBi",
      "member_name": "Antonio Flávio Sanchez de Almeida",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "sSC4K4v7FTVRWr477HLl",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2008-06-04T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41996933784",
      "member_cpf": "59741546904",
      "member_email": "wwsaviolo@hotmail.com",
      "member_id": "ZOnv95UAYN1HGNJLs8R9",
      "member_name": "Wanderley Saviolo Ferreira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-06-04T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "sYqbbfBPKAodlk5inU9O",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22988326090",
      "member_cpf": "75833638615",
      "member_email": "luisrv@terra.com.br",
      "member_id": "FUbEcrzqqkcVhHQXH24q",
      "member_name": "Luís Roberto Velloso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "sZq9n7Q9y1IeIid52OCq",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11953090309",
      "member_cpf": "05975263891",
      "member_email": "lpuig@incor.usp.br",
      "member_id": "5QbDsU1GPb8Dpjo1MWpk",
      "member_name": "Luiz Boro Puig",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "spnx4SyenEKfHrHu3e6O",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41999477700",
      "member_cpf": "02154314996",
      "member_email": "fabiobnavarro@gmail.com",
      "member_id": "7wgRccFQiSVeGruP4z8c",
      "member_name": "Fabio Binhara Navarro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 320,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 320
    }
  }, {
    "id": "stABy19hkQEyRzPxqxpL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "52729613820",
      "member_email": "",
      "member_id": "ktz0Z5Np9FanpQ1xteuO",
      "member_name": "Antonio Carlos da Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "stYzvqkkfMMyVqbZyNAC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21964386131",
      "member_cpf": "55093620734",
      "member_email": "jcarlosjazbik@gmail.com",
      "member_id": "VbMNcKLLrk0hKCI602BU",
      "member_name": "João Carlos Jazbik",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "t2C8GWs0OwWfgtYjpFQf",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16999652217",
      "member_cpf": "48955990600",
      "member_email": "radbianco@hotmail.com",
      "member_id": "yyUucBmHE2M5T48sL1LK",
      "member_name": "Renato Antonio Del Bianco",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "t3RwJoMDr5tA77xKrhG3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "54991565082",
      "member_cpf": "27723151004",
      "member_email": "ffaes@uol.com.br",
      "member_id": "2sKKZE5TkYFdIUEwk9aX",
      "member_name": "Farid Cesar Faes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "tDtPpEBXKHn7DL8UjbFd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999830548",
      "member_cpf": "35267666734",
      "member_email": "marialdacoimbra@hotmail.com",
      "member_id": "QCpe9xbL1EPOwPTVaS9A",
      "member_name": "Marialda M. Coimbra",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "tHLfBamtd3iXqbkTvx3q",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "79999722240",
      "member_cpf": "23638125572",
      "member_email": "rcbarroso21@gmail.com",
      "member_id": "aXVRgQX86zb6TDVDnbC5",
      "member_name": "Roberto Cardoso Barroso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tHm5C9KW7ZN2vXeKi09q",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2008-02-08T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "86999228813",
      "member_cpf": "07778856387",
      "member_email": "sebanmartins@gmail.com",
      "member_id": "7LzGT6rpbbKBfzDnElHB",
      "member_name": "Sebastião Nunes Martins",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-02-08T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "tJ5zRsYtS6Vkg2b8niVI",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2005-04-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11992233402",
      "member_cpf": "15113694851",
      "member_email": "famlarco@terra.com.br",
      "member_id": "JDR4in0ONdxlOxXuzCoR",
      "member_name": "Luís Anibal Larco Patino",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-04-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 371.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 371.99
    }
  }, {
    "id": "tKV8CkoZqrPfPi39n78a",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996260665",
      "member_cpf": "01043328831",
      "member_email": "beatrizfurlanetto@gmail.com",
      "member_id": "HiKwZGC9JxBw28x7X1ub",
      "member_name": "Beatriz Helena S. Furlanetto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tKap9PFM8IDaVF2D0czE",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "41996510727",
      "member_cpf": "92235409920",
      "member_email": "marciofabianobastos@yahoo.com.br",
      "member_id": "rBspyVxHtuv3xXPKkjiu",
      "member_name": "Márcio Fabiano Chaves Bastos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 390.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 390.94
    }
  }, {
    "id": "tLqin9GRZJhzhYH0eexo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(11)994044404",
      "member_cpf": "98312421815",
      "member_email": "s-goldman@hotmail.com",
      "member_id": "Uxn3V6iLOPsIBL12YtoQ",
      "member_name": "Sergio Goldman",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tOmaDxgjbagcQbwKPG5f",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999817900",
      "member_cpf": "05652766034",
      "member_email": "j.dinkhuysen@uol.com.br",
      "member_id": "fVNXav4rEz5KTGiUocDg",
      "member_name": "Jarbas Jakson Dinkhuysen",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tRPPqg5PC0ylx2stScwY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999844757",
      "member_cpf": "25663704604",
      "member_email": "tinalobato@hotmail.com",
      "member_id": "tHqDojmyXOjvWTwUc3OD",
      "member_name": "Rodrigo de Castro Bernardes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tTIKBmDv0ERUWUeK2d8e",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1196547422",
      "member_cpf": "13133712896",
      "member_email": "rc.leca@bol.com.br",
      "member_id": "mbAWd76s8fRRaR2EZBuf",
      "member_name": "Ricardo Cerquinho Galão Leça",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "tUwipmd3MMTCFg5FSe6H",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "22981157553",
      "member_cpf": "45875103787",
      "member_email": "guscouto02@gmail.com",
      "member_id": "yN3YdZoErJL7U75KjI6u",
      "member_name": "Gustavo José Ventura Couto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tVtfP4r86tkPoXCmn3hS",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11973358806",
      "member_cpf": "01043253807",
      "member_email": "furlanettoglaucio@gmail.com",
      "member_id": "gZTsTjlnRl34D1ZWOSBp",
      "member_name": "Glaucio Furlanetto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "tkRrDQJ3skAdXcKZgdEa",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-08-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11983888297",
      "member_cpf": "31974325253",
      "member_email": "raynoldmonteiro@gmail.com",
      "member_id": "hSfcnmw2lQ9ecnchD0s2",
      "member_name": "Raynold Santos Monteiro",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-08-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "tmGgyInAgTf9OcosRDBC",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999823482",
      "member_cpf": "00026498880",
      "member_email": "adriana.indocor@gmail.com",
      "member_id": "kcBHb6Eqi99uFWmwWTfb",
      "member_name": "Rubens Minillo",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "tnv3K6TFoniyUTI0SmD9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11999301616",
      "member_cpf": "08717498821",
      "member_email": "mbjatene@uol.com.br",
      "member_id": "bPK40aNYW7olk4LePR1r",
      "member_name": "Marcelo Biscegli Jatene",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "trEg8iDttHD7gqPXdoAw",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "87468662991",
      "member_email": "lesengenharia@hotmail.com",
      "member_id": "kdI04BclnaGngSgHCZ6f",
      "member_name": "Rogerio Marcos Gaspar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "tuNflYEeV2k4x3TRaMC4",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "35988554530",
      "member_cpf": "71260706672",
      "member_email": "fredericonunes@cardiol.br",
      "member_id": "CjiMZZsxD8DRrc2Edyqb",
      "member_name": "Frederico Nunes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "u2OOXtAILxGFvqvzMYFd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81999040461",
      "member_cpf": "06878356822",
      "member_email": "pedro.salerno@unicap.br",
      "member_id": "ZSAm1sNI0J0iTAAEqc9L",
      "member_name": "Pedro Rafael Salerno",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "uIAGxp10CSL5nu71mZPn",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-22T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "34999791827",
      "member_cpf": "86640038668",
      "member_email": "paulocir@hotmail.com",
      "member_id": "BQ1OXriXdZWCo3YpsGHb",
      "member_name": "Paulo César Santos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-22T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 381.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 381.61
    }
  }, {
    "id": "uJ8IIKXqUv0yQtAbgQlU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991556463",
      "member_cpf": "08229376549",
      "member_email": "cardionr@terra.com.br",
      "member_id": "jj3M86QEr8fT4nxvBz1D",
      "member_name": "Augusto Ferreira Silva Júnior",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "uO0dis6MFj5o0IbT4mIQ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "(15) 3231-1787",
      "member_cpf": "46179992800",
      "member_email": "drfbarros@hotmail.com",
      "member_id": "1ZEYz4c5joBbr0dYtfeH",
      "member_name": "Fernando de Barros Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "uhFjsUP7IYTvqLKR8sqv",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-03-02T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999885896",
      "member_cpf": "76008576772",
      "member_email": "marioamar@uol.com.br",
      "member_id": "UFJ3Ac1G2vumQDKpdZpH",
      "member_name": "Mário Ricardo Amar",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-03-02T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "ukzSTaWi7Boi8eUJlsRx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21993078918",
      "member_cpf": "54362733787",
      "member_email": "heloisafeijo@hotmail.com",
      "member_id": "9JHsRkNYhJ4EbD7Uagxr",
      "member_name": "Alan Tonassi Paschoal",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "ut2mD7cy4kwNZFpcec8t",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996401972",
      "member_cpf": "17893863811",
      "member_email": "mlpsobral@uol.com.br",
      "member_id": "iBeMzxpjIvxNzNyIf61z",
      "member_name": "Marcelo Luiz Peixoto Sobral",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "v6JSrNbXI9X00zpc7HDe",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16981249057",
      "member_cpf": "04270754834",
      "member_email": "tenocastilho@uol.com.br",
      "member_id": "sfZbgUKRN63KLh6WTeDU",
      "member_name": "Oswaldo Teno Castilho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "vKZBQNd2L1hdMLsammLM",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "H2AoWhktluQaWYuPydHC",
      "category_name": "Não Sócio",
      "date": "2004-02-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61999618837",
      "member_cpf": "37086910163",
      "member_email": "jeancost@gmail.com",
      "member_id": "1by0gqyVoLHh8Fg0kfTV",
      "member_name": "Jean Newton Lima Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-02-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 80,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 80
    }
  }, {
    "id": "vb7OrHJy8ddrglw1ceI0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2006-01-25T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "94999729988",
      "member_cpf": "04546199287",
      "member_email": "santanaadilsonf@uol.com.br",
      "member_id": "OquFh3sYmer5AjDbXEw7",
      "member_name": "Adilson Fernandes Santana",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-01-25T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "vjrGSG6N7dL0gGXoRKt1",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81999720206",
      "member_cpf": "40213900491",
      "member_email": "mauroarrudafilho@hotmail.com",
      "member_id": "PKjfvOcxsrIemox3jl4E",
      "member_name": "Mauro Barbosa Arruda Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "vlX8QyDaQGvRgXXqY66L",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11985841097",
      "member_cpf": "52543439820",
      "member_email": "jernesto@succi.com.br",
      "member_id": "ME5QcLwPlwCF7cJIrHEh",
      "member_name": "José Ernesto Succi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "vquIphsucQUOZKM3TtST",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3732122716",
      "member_cpf": "72285931620",
      "member_email": "ariangelomesquita@gmail.com.br",
      "member_id": "RWIZ208qCLrmUnFNXea6",
      "member_name": "Ariangelo Araujo Mesquita",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "vr6ePH4qeeBn8RiwJzWV",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "54991050513",
      "member_cpf": "22577270020",
      "member_email": "fragomeni@annex.com.br",
      "member_id": "T61PdKWZltYkGqkkaHsT",
      "member_name": "Luís Sérgio de M. Fragomeni",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "w00A8RTyQbUSAYKLeEvt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-03T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "04922477803",
      "member_email": "wilsoncouto10@yahoo.com.br",
      "member_id": "JBMtZDMPflWtzBhxB5NV",
      "member_name": "Wilson Jose Couto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-03T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "wHYTXwdOqXXf5QyZCPBP",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-09-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21999615463",
      "member_cpf": "22158847700",
      "member_email": "macunha084@hotmail.com",
      "member_id": "VuaXN3IT66I9fC9kHiBR",
      "member_name": "Marco Antonio Cunha",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-09-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "wMUXqDeEjsPOHJpwcra9",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "XkNpL8lctQ82mVgSXruw",
      "category_name": "Membro Aspirante",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "21988269939",
      "member_cpf": "00701828765",
      "member_email": "ailtonjuniorrj@gmail.com",
      "member_id": "gurv9KVS8e3q7Jvmc8wy",
      "member_name": "Ailton Carvalho Barbosa Jr.",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 376.78,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 376.78
    }
  }, {
    "id": "wMmVzzvAPL8DsAtJmylL",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "82996155000",
      "member_cpf": "06162355420",
      "member_email": "jwneto@uol.com.br",
      "member_id": "ifgnNJhEmY84MFU1gQjF",
      "member_name": "José Wanderley Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "wdcqTfWSlV4mKTxBtv3M",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999881400",
      "member_cpf": "00100927300",
      "member_email": "cesargondim@secrel.com.br",
      "member_id": "rZLeWUoBfKMOF899tUv4",
      "member_name": "Raimundo Cesar Barbosa Gondim",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "wmkbTfORhLWRVgF6Mp6m",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999729228",
      "member_cpf": "44266669968",
      "member_email": "waltervosgrau0@gmail.com",
      "member_id": "sVa7QmQMK9jcapa0gVdC",
      "member_name": "Walter Vosgrau Fagundes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 345.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 345.6
    }
  }, {
    "id": "wncpekWMlIgPhdlrdWhH",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999850710",
      "member_cpf": "39195953604",
      "member_email": "fernando.roquette@yahoo.com.br",
      "member_id": "Mcvc4sHHB11aTzQdlAIP",
      "member_name": "Fernando Antonio Roquette Reis Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "wukcHeA0ZLo9VQohNBxG",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61999723451",
      "member_cpf": "85821250544",
      "member_email": "helmgton@icloud.com",
      "member_id": "Tt7lZYngIRb4k1gISR8e",
      "member_name": "Helmgton José Brito de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "wvBj7AdnGQLGwaP7XPFp",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "1199708289",
      "member_cpf": "00533054850",
      "member_email": "ddlf@uol.com.br",
      "member_id": "qZnMWdj4UpBMMOI6sbtD",
      "member_name": "Domingos Dias Lourenco Filho",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "wvlKnBRGVLq1wMoQrpFJ",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19981190927",
      "member_cpf": "19235860849",
      "member_email": "rkv@uol.com.br",
      "member_id": "fynO8bEc4yfKLGbUMAZY",
      "member_name": "Reinaldo Wilson Vieira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 469.82,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 469.82
    }
  }, {
    "id": "wwDo2438ry2FWN5WdvLe",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11983394139",
      "member_cpf": "03993949820",
      "member_email": "drsao@uol.com.br",
      "member_id": "CDzv5p6NMAbelZCM5DIP",
      "member_name": "Sérgio Almeida de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "x0Jr3hpHnE73B7laUVIF",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11982734000",
      "member_cpf": "15525236915",
      "member_email": "cleidet@einstein.br",
      "member_id": "4DzEox5JVXbTaeRQOzkK",
      "member_name": "Rolf Francisco Bub",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "x51dfjN94bkB81mN0Bvb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11991472636",
      "member_cpf": "05154341830",
      "member_email": "wjgomes1012@gmail.com",
      "member_id": "zUJF3rGEzCCujnzfeA9P",
      "member_name": "Walter José Gomes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "x6ZkogAyIZotv8Gvw0Sf",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "81099725322",
      "member_cpf": "03869024453",
      "member_email": "ahilsonrobertocorreia@ig.com.br",
      "member_id": "zWi6hnngeDH1TPIupMUV",
      "member_name": "Ahilson Roberto Correia",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "xFA3imE16TAisVePDr6C",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-19T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "19996084047",
      "member_cpf": "07044014879",
      "member_email": "vinicius@sbccv.org.br",
      "member_id": "Pv3v9CDkWs3owyJSp2rY",
      "member_name": "Marcus Vinicius Ferraz de Arruda",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-19T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "xJpdFRkikQfDsIgv0Igt",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62999718586",
      "member_cpf": "03303360880",
      "member_email": "drpaulocouto@uol.com.br",
      "member_id": "o9CCurNLYUTu8x5StAaJ",
      "member_name": "Paulo de Tarso do Couto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "xRlLYtXy9zErOgceE2Lh",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-11-30T02:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "2199852450",
      "member_cpf": "01637573434",
      "member_email": "claudior@cardiol.br",
      "member_id": "iHvh11kfTSjKEa8EqerB",
      "member_name": "Claudio Roberto Cavalcante Assumpcao",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-11-30T02:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 106.68,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 106.68
    }
  }, {
    "id": "xahQOp6aeZ53bg7FH7Zx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16991143680",
      "member_cpf": "86530470859",
      "member_email": "edson.margarido@gmail.com",
      "member_id": "cx8w2U8xMhvYkGXvdDfb",
      "member_name": "Edson Alves Margarido",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "xgyLzn2xzAQXUFFEfG22",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-04-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "91981145338",
      "member_cpf": "32726813291",
      "member_email": "dionisio.o.bentes@icloud.com",
      "member_id": "QuBCcGXDoEu8Ys5dnCes",
      "member_name": "Dionísio Otavio Bentes Carvalho Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-04-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 359.98,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 359.98
    }
  }, {
    "id": "xiTDadTEKvMiz005YyD3",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51999865224",
      "member_cpf": "06605257049",
      "member_email": "jbpetracco@terra.com.br",
      "member_id": "LYedefLTXDc51HZ1hyOP",
      "member_name": "João Batista Petracco",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "xjzbN3DV9O9rIsfBJ8tc",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "vPFeWOFfTUGjYKQ4dd3C",
      "category_name": "Membro Associado",
      "date": "2004-03-10T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "42999721177",
      "member_cpf": "73076473972",
      "member_email": "fernando.laforga@sbccv.org.br",
      "member_id": "mZhB6qIRyDpmk0Q33eAF",
      "member_name": "Fernando César Laforga",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-10T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "xnPlhmt44OosdQPqRaV6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "79991422299",
      "member_cpf": "04530969568",
      "member_email": "jteles@infonet.com.br",
      "member_id": "pw7FmMZMBTtsbcRfAVBk",
      "member_name": "José Teles de Mendonça",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "xx3tWkCPNsr5SQHIg3x8",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67999812728",
      "member_cpf": "22718877120",
      "member_email": "maurocosme54@gmail.com",
      "member_id": "jhqm6gcngGLkcwa2YrKG",
      "member_name": "Mauro Cosme Gomes de Andrade",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "xyiReGZdqXPkyrCOi5cp",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "06135005391",
      "member_email": "",
      "member_id": "FefwKLWdySfKkXSSBXwo",
      "member_name": "Fernando Antonio Mesquita",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "y39bq3ZofsztWYEfd5T6",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2006-03-30T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11974527184",
      "member_cpf": "01108892825",
      "member_email": "sluzzi@uol.com.br",
      "member_id": "5IdR4XX6CSMGT4afAtge",
      "member_name": "Sergio Luzzi",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2006-03-30T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "y49DN1dncMJLYgVsB9EO",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "17996013650",
      "member_cpf": "32234481104",
      "member_email": "joaocarlosleal@hotmail.com.br",
      "member_id": "487mQwdaZGJfbJ8NbJ9n",
      "member_name": "João Carlos Ferreira Leal",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "yLHARIuOdBuHUTdaQg0x",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-07-07T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31992963449",
      "member_cpf": "99238756791",
      "member_email": "carlaoliveiraccv@gmail.com",
      "member_id": "2Z92kFxS6j47faXz48Ky",
      "member_name": "Carla de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-07-07T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "yN3P19huJrEvCmrWCjHb",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "31999834546",
      "member_cpf": "11882026691",
      "member_email": "consultorio3@yahoo.com.br",
      "member_id": "uV3qLRRwfkVR4vGrpj1V",
      "member_name": "Carlos Camilo Smith Figueroa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "yTj6CJo4BG9ELnB7XgVj",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "85999818465",
      "member_cpf": "26179229368",
      "member_email": "jafeitosa@uol.com.br",
      "member_id": "qVL41kgayq3PXQf2bGZ6",
      "member_name": "José Acácio Feitosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 424.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 424.99
    }
  }, {
    "id": "yUDCDMbYftdh2hLsnKa0",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-05-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "16999911065",
      "member_cpf": "81927126800",
      "member_email": "castilhoteno@gmail.com",
      "member_id": "Pv0mSjwxMLuDp8OdKP3H",
      "member_name": "Luiz Antonio Castilho Teno",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "yUVaoZ1KYxcx2iFGPhvU",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2005-07-29T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "71991651982",
      "member_cpf": "47514213872",
      "member_email": "gpieracciani@msn.com",
      "member_id": "5ThrSSFCdxIyqKFyvBHd",
      "member_name": "Giorgio Pieracciani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-07-29T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "yYRK6BRej3UWayBKQOtT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11983639957",
      "member_cpf": "77938445720",
      "member_email": "jhpalma@terra.com.br",
      "member_id": "5yrGDXcl3mMyHZSJbuow",
      "member_name": "José Honório de Almeida Palma Fonseca",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "yZw7W0nNI9hSG4AwJzMK",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-11T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "7199776166",
      "member_cpf": "28249046587",
      "member_email": "pmaporciuncula@hotmail.com",
      "member_id": "ceaLKvB1UHaeQKiBVV42",
      "member_name": "Paulo Moniz de A. Porciuncula",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-11T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 499.99,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 499.99
    }
  }, {
    "id": "ykkg23Ug2eqKsR21RjbB",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "67984035686",
      "member_cpf": "72077476672",
      "member_email": "caranas@terra.com.br",
      "member_id": "XD78iuyp1yvlb2tEBbiE",
      "member_name": "Carlos Idelmar de Campos Barbosa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 400,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 400
    }
  }, {
    "id": "ypmH9omARtbhguN9D8nd",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "09163913887",
      "member_email": "marisa.siqueira@incor.usp.br",
      "member_id": "u9APvDWrxYmGIyMAKHVa",
      "member_name": "Pedro Carlos Piantino Lemos",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "yvqUibTP8fyVjn9xSLyA",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-17T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "51996780861",
      "member_cpf": "15459101034",
      "member_email": "mgoldani@yahoo.com.br",
      "member_id": "cTtBxRWhmahOG7q7b4Sf",
      "member_name": "Marco Antonio Goldani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-17T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "z5YSONCf4a6da8ClJQbT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-08-25T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "37999877984",
      "member_cpf": "61474223834",
      "member_email": "liberatosavio@yahoo.com.br",
      "member_id": "Qg12nQgE4S75egYT3joY",
      "member_name": "Liberato Sávio Siqueira de Souza",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-08-25T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 358.93,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 358.93
    }
  }, {
    "id": "z65mERPo3S7rrh5qRkcT",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "62992063887",
      "member_cpf": "88822095804",
      "member_email": "joaoalbertopansani@gmail.com",
      "member_id": "YARkvgiER9wrhor3QKun",
      "member_name": "João Alberto Pansani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 297.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 297.61
    }
  }, {
    "id": "z8dfa1x8hpfkEGLLXWDu",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "47996163227",
      "member_cpf": "25100869879",
      "member_email": "jpaesm1@gmail.com",
      "member_id": "5EDcn8ATlMwTPCBk9zTE",
      "member_name": "Márcio José Paes",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 240,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 240
    }
  }, {
    "id": "zB6cwgVCjKiyokwfMIr2",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "B8PSEcvlWnLwvwwB0NOR",
      "category_name": "Membro Remido",
      "date": "2004-03-12T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "61999814836",
      "member_cpf": "05548799134",
      "member_email": "lcschimin@sbccv.org.br",
      "member_id": "KRdq6EKkMOplzsaARGN7",
      "member_name": "Luiz Carlos Schimin",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-12T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 365.6,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 365.6
    }
  }, {
    "id": "zBettJP7ek9aT2MwhkZY",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2008-04-18T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "8293271312",
      "member_cpf": "15400654487",
      "member_email": "clebercardio_@hotmail.com",
      "member_id": "U1B2Vc0Jm0x1725IrEty",
      "member_name": "Cleber Costa de Oliveira",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2008-04-18T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "zEVU8zBKzUBLMOPn0wSo",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "9SWyrc8TgRaUEWmfkr95",
      "category_name": "Membro Titular",
      "date": "2004-03-31T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "11996417333",
      "member_cpf": "94984840820",
      "member_email": "saverioa@terra.com.br",
      "member_id": "nwPjfm9A9X2BaMSMsD9Q",
      "member_name": "Savério Angrisani Neto",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-31T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "zb3BPtGItRZ3vtQGMvnz",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-16T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3186359002",
      "member_cpf": "60847808653",
      "member_email": "gversiani@msn.com",
      "member_id": "LgifPaqZPGHO6N99SKrF",
      "member_name": "Giovani Cardoso Versiani",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-16T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 374.94,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 374.94
    }
  }, {
    "id": "zbh9VeqJoqSTlJU5RV7Z",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2004-03-15T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "",
      "member_cpf": "66508754815",
      "member_email": "janiobc@cardiol.br",
      "member_id": "k0OfmlApcZPEaXtDhhmX",
      "member_name": "Janio Benito Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-15T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 397.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 397.61
    }
  }, {
    "id": "zjbGsprBsavaxFm1Bcgx",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2007-04-09T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "8196140754",
      "member_cpf": "14547201404",
      "member_email": "jorvieira@terra.com.br",
      "member_id": "HTrIdZNTIz8RyxwZv6JC",
      "member_name": "Jorge Vieira Rodrigues",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-04-09T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 500,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 500
    }
  }, {
    "id": "zodBmBUMlE993kbDn0Cr",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "Vcz1zswnpasyelxbe176",
      "category_name": "Falecido",
      "date": "2004-03-08T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "14996917878",
      "member_cpf": "54313635815",
      "member_email": "marcos@fmb.unesp.br",
      "member_id": "ViSzq1T0UBh4qYPmfTZq",
      "member_name": "Marcos Augusto de Moraes Silva",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2004-03-08T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 465.61,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 465.61
    }
  }, {
    "id": "zs2yEuBKfTkjIfKJ530W",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "KRJzzZtrH9SIl4JHzmFy",
      "category_name": "Membro Desligado",
      "date": "2007-03-28T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "3199813718",
      "member_cpf": "42603706691",
      "member_email": "lafcardoso@hotmail.com",
      "member_id": "ZP5I3jT9JTaaEOUPoBrY",
      "member_name": "Luiz Antonio de Freitas Cardoso",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2007-03-28T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 425,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 425
    }
  }, {
    "id": "zua2Sul4hKY2u8mZyB81",
    "data": {
      "Tid": "",
      "authorizationCode": "",
      "card_brand": "",
      "category_id": "f9IKy8nfJsjvBwO390uT",
      "category_name": "Membro Especialista",
      "date": "2005-05-20T03:00:00.000Z",
      "evventSlots": "",
      "member_cellPhone": "82999213491",
      "member_cpf": "46953132434",
      "member_email": "monica.farias@hotmail.com",
      "member_id": "GWUvLVCiXXoDeVLiEWO1",
      "member_name": "Maria Mônica de Farias Costa",
      "origin": "GN1-i",
      "payAsOverdue": false,
      "paymentId": "",
      "payment_date": "2005-05-20T03:00:00.000Z",
      "payment_type": "Boleto",
      "product_id": "t1RvzJlW5CbjzImWd5Cg",
      "product_name": "Anuidade 2004 • SBCCV",
      "proofOfSale": "GN1-2004",
      "returnCode": "00",
      "staff": false,
      "total": 394.65,
      "total_minus_tax": 0,
      "type": "Boleto",
      "value": 394.65
    }
  }]

}

}
